import { formatPropertyAddress, formatStreetAddress } from '../utils/propertyAddress';
import FleetPropertyDetailActions from './FleetPropertyDetailActions';
import SearchFilterPanel from './SearchFilterPanel';
import {SavedPropertyLists,PropertyListPicker,PropertyListMembership} from './PropertyLists';
import MapPlaceLayers from './MapPlaceLayers';
import MapPropertyGrid from './MapPropertyGrid';
import {mapCoordinates} from '../utils/propertyCoordinates';
import {clusterBubbleIcon,propertyMapIcon} from '../utils/mapMarkerIcons';
import {addIllustratedBasemap} from '../services/illustratedBasemap';
import { propertyFetch } from '../services/idxPropertyClient';
import { loadPropertyMedia, propertyMediaUrls } from '../services/propertyMedia';
import { rememberPropertyPhoto } from '../services/propertyThumbnails';
import PropertyThumbnail from './PropertyThumbnail';
import { getPropertyShareUrl } from '../utils/propertySharing';
import LegacyMobilePropertyBrowser from './LegacyMobilePropertyBrowser';
import { submitChatLead } from '../services/chatLeadService';
import { writeSaveStorage } from '../services/propertySaveStorage';
import { usePropertySave } from './PropertySaveProvider';
import PropertyLocationMap from './PropertyLocationMap';
import {loadPropertyPage,loadPropertyMap,loadPrivateMapRows} from '../utils/boundedPropertySearch';
import {attachBoundedMap,renderBoundedFeatures,viewportBounds} from '../utils/boundedMapLayer';
import './BoundedMap.css';
import './PropertySearchLayout.css';
import RobustSearchControls from './RobustSearchControls';
import { searchSnapshot, searchQuery, searchFromQuery, assertValidSearch, readSearchError, ROBUST_NAMES } from '../utils/propertySearchFilters';
import { applyManualSearchFilters } from '../utils/manualSearchFilters';
// src/components/ActionButtons.js
import React, { useState, useEffect, useRef } from 'react';
import { chatSearchSnapshot, loadChatProperties, mergeChatProperties } from '../utils/chatPropertySearch';
import { useNavigate } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import {SITE_CONFIG} from '../config';
import { useTheme } from '../contexts/ThemeContext';
import './ActionButtons.css';
import './MapDarkMode.css';

import HoneypotField, { isHoneypotSubmission } from './HoneypotField';
import './MapControls.css';

// FLEET_FRONTEND_PACKAGE_2026
const POPULAR_SEARCH_AREAS = Object.keys(SITE_CONFIG.LANDING_PAGE?.CITY_IMAGES || {})
  .slice(0, 6)
  .map((key) => key.toLowerCase().split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' '));

const ActionButtons = ({ activeSection, setActiveSection, isGlobeMap, onGlobeMapClose, onGlobeMapResultsChange, directListingKey, user, isAdmin, setUser, setIsAdmin, hidePrompts }) => {
  const { favorites, collections, toggleFavorite } = usePropertySave();

  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const propertyImagesRef=useRef({});
  const [listingKey,setListingKey]=useState('');
  const [acreage,setAcreage]=useState('');
  const [communityFeatures,setCommunityFeatures]=useState([]);
  const [minBathrooms,setMinBathrooms]=useState('');
  const [maxBathrooms,setMaxBathrooms]=useState('');
  const [hasPool,setHasPool]=useState(false);

  const [mapStats,setMapStats]=useState({});
  const [lensMapData,setLensMapData]=useState(null);
  const initialMapRequestRef=useRef(0), initialMapAbortRef=useRef(null),lensAbortRef=useRef(null),chatAbortRef=useRef(null);
  const moreRequestsRef=useRef(new Map()),mapPreviewRequestsRef=useRef(new Map());
  useEffect(()=>()=>{initialMapRequestRef.current++;initialMapAbortRef.current?.abort();lensAbortRef.current?.abort();chatAbortRef.current?.abort();moreRequestsRef.current.forEach(controller=>controller.abort());chatGenerationRef.current++;},[]);

  const initialSearchQueryRef = useRef(window.location.search);
  const sharedSearchRef = useRef(searchFromQuery(initialSearchQueryRef.current));
  const [advancedFilters, setAdvancedFilters] = useState(() => Object.fromEntries(Object.entries(sharedSearchRef.current).filter(([key]) => [...ROBUST_NAMES, 'minGarageSpaces', 'newConstruction', 'hasPrivatePool', 'waterfront', 'hasBasement', 'hasAttachedGarage', 'state'].includes(key))));
  const [manualSearchError, setManualSearchError] = useState('');
  const appliedSearchRef = useRef(sharedSearchRef.current);
  const applyManualFilters = query => {
    for(const [key,value] of Object.entries({listingKey,minBathrooms,maxBathrooms,hasPool:hasPool||undefined})) {query.delete(key);if(value!==''&&value!==undefined)query.set(key,String(value));}
    query.delete('communityFeatures');communityFeatures.forEach(value=>query.append('communityFeatures',value));
    if(acreage){query.delete('minLotSizeAcres');query.delete('maxLotSizeAcres');if(acreage==='<5')query.set('maxLotSizeAcres','5');else if(acreage==='5to10'){query.set('minLotSizeAcres','5');query.set('maxLotSizeAcres','10');}else if(acreage==='10+')query.set('minLotSizeAcres','10');}
    if (SITE_CONFIG.SEARCH_STATES && !query.has('state') && !query.has('listOfficeKeyNumeric')) {
      SITE_CONFIG.SEARCH_STATES.forEach(state => query.append('state', state));
    }
    applyManualSearchFilters(query, advancedFilters, sharedSearchRef.current);
    sharedSearchRef.current = null;
    setManualSearchError('');
  };

  const localFavoritesKey = `propertyFavorites_${SITE_CONFIG.SITE_ID}`;
  const [showPrompts, setShowPrompts] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [showSecondMessage, setShowSecondMessage] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [propertyLocation, setPropertyLocation] = useState('');
  const [propertySize, setPropertySize] = useState('');
  const [propertyCondition, setPropertyCondition] = useState('');
  const [sellingTimeline, setSellingTimeline] = useState('');
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);
  const [zipCode, setZipCode] = useState('');
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [messages, setMessages] = useState([]);
  const messagesContainerRef = useRef(null);
  const chatSearchContextRef = useRef(null);
  const chatGenerationRef = useRef(0);
  const chatRequestInFlightRef = useRef(false);
  const chatPropertyRequestRef = useRef(0);
  const chatSiteId = SITE_CONFIG.SITE_ID;
  const [isThinking, setIsThinking] = useState(false);
  const [isPropertySearching, setIsPropertySearching] = useState(false);

  useEffect(() => {
    chatSearchContextRef.current = null;
    chatRequestInFlightRef.current = false;
    setMessages([]);
    setIsThinking(false);
    setIsPropertySearching(false);
    return () => {
      chatGenerationRef.current += 1;
      chatPropertyRequestRef.current += 1;
    };
  }, [chatSiteId]);
  const [showRegistration, setShowRegistration] = useState(false);
  const [regEmail, setRegEmail] = useState('');
  const [regName, setRegName] = useState('');
  const [regPassword, setRegPassword] = useState('');
  const [regPhoneNumber, setRegPhoneNumber] = useState('');
  const [regFullName, setRegFullName] = useState('');
  const [showLogin, setShowLogin] = useState(false);
  const [loginUsername, setLoginUsername] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [properties, setProperties] = useState([]);
  const [showProperties, setShowProperties] = useState(false);
  const [expandedMap, setExpandedMap] = useState(null);
  const [placesExpandedMapInstance,setPlacesExpandedMapInstance]=useState(null);
  const mapRef = useRef(null);
  const leafletMapRef = useRef(null);
  const [locationInput, setLocationInput] = useState('');
  const [globeMap, setGlobeMap] = useState(() => {
    if(!isGlobeMap || new URLSearchParams(window.location.search).get('saved')!=='true')return null;
    const saved=sessionStorage.getItem('globeMapData');sessionStorage.removeItem('globeMapData');
    try{return saved?JSON.parse(saved):null;}catch{return null;}
  });
  useEffect(() => {
    if (onGlobeMapResultsChange) {
      onGlobeMapResultsChange(Boolean(globeMap));
    }
  }, [globeMap, onGlobeMapResultsChange]);

  const globeMapRef = useRef(null);
  const globeLeafletRef = useRef(null);
  const [propertySubType, setPropertySubType] = useState('');
  const [minBedrooms, setMinBedrooms] = useState('');
  const [maxBedrooms, setMaxBedrooms] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [propertyDetail, setPropertyDetail] = useState(null);
  const [propertyImages, setPropertyImages] = useState({});
  useEffect(()=>{propertyImagesRef.current=propertyImages;},[propertyImages]);
  const [propertyDetailImages, setPropertyDetailImages] = useState([]);
  const [imagesLoading, setImagesLoading] = useState(false);
  const detailRequestRef = useRef(0);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [enlargedImageIndex, setEnlargedImageIndex] = useState(0);
  const [promptCount, setPromptCount] = useState(0);
  const [sendButtonEnabled, setSendButtonEnabled] = useState(false);
  const [showAgentListings, setShowAgentListings] = useState(false);
  const [propertyType, setPropertyType] = useState('');
  const [likedProperties, setLikedProperties] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(localFavoritesKey) || '[]');
      return new Set(Array.isArray(saved) ? saved : []);
    } catch (error) {
      return new Set();
    }
  });
  useEffect(() => { setLikedProperties?.(favorites); }, [favorites, setLikedProperties]);

  const [savedHomesLoading, setSavedHomesLoading] = useState(false);
  const [savedHomesError, setSavedHomesError] = useState('');
  useEffect(() => {
    try {
      localStorage.setItem(localFavoritesKey, JSON.stringify([...likedProperties]));
    } catch (error) {
      // The CRM-backed save flow remains available without browser storage.
    }
  }, [likedProperties, localFavoritesKey]);
  const [isGlobeMapLoading, setIsGlobeMapLoading] = useState(false);

  const [showCopySuccess, setShowCopySuccess] = useState(false);
  const [showAiStaging, setShowAiStaging] = useState(false);
  const [stagingType, setStagingType] = useState('');
  const [stagingImage, setStagingImage] = useState(null);
  const [stagingLoading, setStagingLoading] = useState(false);
  const [hasMedia, setHasMedia] = useState(false);
  const [minSqft, setMinSqft] = useState('');
  const [maxSqft, setMaxSqft] = useState('');
  const [stories, setStories] = useState('');
  const [minYearBuilt, setMinYearBuilt] = useState('');
  const [maxYearBuilt, setMaxYearBuilt] = useState('');
  const [hasFence, setHasFence] = useState(false);
  const [foundation, setFoundation] = useState('');
  const [schoolDistrict, setSchoolDistrict] = useState('');
  const [priceSort, setPriceSort] = useState('');
  const [listingDateSort, setListingDateSort] = useState('');
  const [mapView, setMapView] = useState(true);
  const [hybridView,setHybridView]=useState(true);
  const [mapTrayExpanded,setMapTrayExpanded]=useState(false);
  const [hybridMapInstance,setHybridMapInstance]=useState(null);
  const [activeMapTool,setActiveMapTool]=React.useState(null);
  const setPlacesOpen=React.useCallback(open=>setActiveMapTool(open?'places':null),[]);
  const setAlertsOpen=React.useCallback(open=>setActiveMapTool(open?'alerts':null),[]);
  React.useEffect(()=>setActiveMapTool(null),[propertyDetail,expandedMap,mapView]);
  const [listViewPage, setListViewPage] = useState(0);
  const [itemsPerPage] = useState(6);
  const [openChat, setOpenChat] = useState(false);
  const [showSellerLeadCapture, setShowSellerLeadCapture] = useState(false);
  const [pendingSellerParams, setPendingSellerParams] = useState(null);
  const [pendingBuyerParams, setPendingBuyerParams] = useState(null);
  const [chatLeadSubmitted, setChatLeadSubmitted] = useState(false);

  useEffect(() => {
    const fetchFeatureFlags = async () => {
      try {
        const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/feature-flag?siteId=${SITE_CONFIG.SITE_ID}`, {
          headers: { 'X-API-Key': 'treas-api-key-2025' }
        });
        if (response.ok) {
          const data = await response.json();
          setOpenChat(data.openChat || false);
        }
      } catch (error) {
        console.error('Error fetching feature flags:', error);
      }
    };
    fetchFeatureFlags();
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const stored = localStorage.getItem('chatLead');
    if (stored) {
      const { name: n, email: e, phoneNumber: p } = JSON.parse(stored);
      if (n && !name) setName(n);
      if (e && !email) setEmail(e);
      if (p && !phoneNumber) setPhoneNumber(p);
      setChatLeadSubmitted(true);
    }
  }, []);

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    if (showRegistration || showLogin || selectedService) {
      setTimeout(scrollToBottom, 200);
    }
  }, [showRegistration, showLogin, selectedService]);

  // Handle direct listing access
  useEffect(() => {
    if (directListingKey && isGlobeMap) {
      fetchPropertyDetailByListingKey(directListingKey);
      // Clear the session storage after use
      sessionStorage.removeItem('directListingKey');
    }
  }, [directListingKey, isGlobeMap]);

  useEffect(() => {
    if (expandedMap && mapRef.current) {
      // Clean up existing map
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
      }

      // Create new map
      const map = L.map(mapRef.current,{minZoom:1,maxZoom:19}).setView([expandedMap.lat, expandedMap.lon], 15);

      addIllustratedBasemap(map);

      // Add house marker
      const houseIcon = L.divIcon({
        html: '🏠',
        className: 'house-marker',
        iconSize: [30, 30],
        iconAnchor: [15, 15]
      });

      L.marker([expandedMap.lat, expandedMap.lon], { icon: houseIcon }).addTo(map);

      leafletMapRef.current = map;
      setPlacesExpandedMapInstance(map);
    }

    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
        setPlacesExpandedMapInstance(null);
      }
    };
  }, [expandedMap]);

  const commonPrompts = [
    { display: "Sign in", value: "Sign in" },
    { display: zipCode ? `Show me properties in ${zipCode}` : "Show me properties", value: zipCode ? `Show me properties in ${zipCode}` : "Show me properties" },
    { display: "Register", value: "Register" },
    { display: "Contact David Hamady", value: "Contact David Hamady" },
    { display: "About us", value: "About us" },
    { display: "Contact Info", value: "What is the real estate agents contact info" }
  ];

  const handlePromptSelect = (promptValue) => {
    setInputValue(promptValue);
    setShowPrompts(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = isHoneypotSubmission(e.currentTarget) ? { ok: true } : await submitChatLead(new URL(`https://tophamtechbe.com/api/treas/idx/v1/chatleads?postalCode=${encodeURIComponent(zipCode)}&name=${encodeURIComponent(name)}&phoneNumber=${encodeURIComponent(phoneNumber)}&serviceReq=${encodeURIComponent(selectedService)}&email=${encodeURIComponent(email)}&siteId=${SITE_CONFIG.SITE_ID}`).searchParams, { rememberContact: true });

      if (response.ok) {
        console.log('Form submitted successfully');
        // Clear form but keep customer info for later use
        // setZipCode(''); // Keep zip code for property search
        // Keep name, phone, email for selling details form
        // setName('');
        // setPhoneNumber('');
        // setEmail('');
        // Show thank you message
        setShowThankYouMessage(true);
        setTimeout(scrollToBottom, 200);
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!inputValue.trim() || chatRequestInFlightRef.current || isPropertySearching) return;

    // Add user message
    const userMessage = { type: 'user', content: inputValue };
    setMessages(prev => [...prev, userMessage]);
    setPromptCount(prev => prev + 1);

    const messageToSend = inputValue;
    const lowerMessage = inputValue.toLowerCase();
    setInputValue('');

    // Check for sign in keywords
    if (lowerMessage.includes('sign in') || lowerMessage.includes('signin') || lowerMessage.includes('login') || lowerMessage.includes('log in')) {
      setShowLogin(true);
      const botMessage = { type: 'bot', content: 'I\'ll help you sign in. Please enter your credentials below:' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    chatRequestInFlightRef.current = true;
    const generation = chatGenerationRef.current;
    setIsThinking(true);
    try {
      const response = await fetch('https://tophamtechbe.com/llm/v1/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          capabilities: ['robust_search_v1'],
          message: messageToSend,
          site_id: SITE_CONFIG.SITE_ID,
          ...(chatSearchContextRef.current?.siteId === chatSiteId
            ? { search_context: chatSearchContextRef.current.params } : {}),
          conversation_history: messages.filter(msg => msg.content !== 'properties').map(msg => ({
            role: msg.type === 'user' ? 'user' : 'assistant',
            content: msg.content
          }))
        })
      });

      if (response.ok) {
        const data = await response.json();
        if (generation !== chatGenerationRef.current) return;
        // Add bot response
        const botMessage = { type: 'bot', content: data.response };
        setMessages(prev => [...prev, botMessage]);

        // Handle action if present
        if (data.action) {
          console.log('Action received:', data.action, data.params);
          await handleAction(data.action, data.params);
        }
      } else {
        if (generation !== chatGenerationRef.current) return;
        const errorMessage = { type: 'bot', content: 'Sorry, I\'m having trouble connecting right now. Please try again later.' };
        setMessages(prev => [...prev, errorMessage]);
      }
    } catch (error) {
      if (generation !== chatGenerationRef.current) return;
      console.error('Error sending message:', error);
      const errorMessage = { type: 'bot', content: 'Sorry, I\'m having trouble connecting right now. Please try again later.' };
      setMessages(prev => [...prev, errorMessage]);
    } finally {
      if (generation === chatGenerationRef.current) {
        chatRequestInFlightRef.current = false;
        setIsThinking(false);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage(e);
    }
  };

  const submitSellerInquiry = async (params, userEmail, userName, userPhone) => {
    try {
      const queryParams = new URLSearchParams({
        location: params.location,
        propertyDetails: params.property_details,
        email: userEmail,
        phoneNumber: userPhone,
        name: userName,
        siteId: SITE_CONFIG.SITE_ID
      });

      if (params.address) {
        queryParams.append('address', params.address);
      }

      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/selling-inquiry?${queryParams}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        console.log('Seller inquiry submitted successfully');
      } else {
        console.error('Failed to submit seller inquiry');
      }
    } catch (error) {
      console.error('Error submitting seller inquiry:', error);
    }
  };

  const storeConversation = async (params) => {
    try {
      const queryParams = new URLSearchParams({
        reason: params.reason || 'inquiry',
        contactInfo: email || params.contactInfo || '',
        conversationSummary: params.conversationSummary || '',
        phone: phoneNumber || params.phone || '',
        name: name || params.name || '',
        siteId: SITE_CONFIG.SITE_ID
      });

      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/store-convo?${queryParams}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        console.log('Conversation stored successfully');
      } else {
        console.error('Failed to store conversation');
      }
    } catch (error) {
      console.error('Error storing conversation:', error);
    }
  };

  const sendAgentSMS = async (customerName, customerPhone) => {
    try {
      const formData = new FormData();
      formData.append('to', SITE_CONFIG.AGENT.PHONE);
      formData.append('body', `Agent Winds Message: ${customerName} has requested you contact them at ${customerPhone}`);

      const response = await fetch('https://tophamtechbe.com/api/treas/comm/send-sms', {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        },
        body: formData
      });

      if (response.ok) {
        console.log('SMS sent to agent successfully');
      } else {
        console.error('Failed to send SMS to agent');
      }
    } catch (error) {
      console.error('Error sending SMS to agent:', error);
    }
  };

  const handleGetCRM = async () => {
    const userEmail = user?.email || email;
    if (!userEmail) {
      const botMessage = { type: 'bot', content: 'Please sign in to view your progress status.' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    try {
      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/crm?email=${encodeURIComponent(userEmail)}&siteId=${SITE_CONFIG.SITE_ID}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        const data = await response.json();
        const stages = ['lead', 'discover', 'onboard', 'research', 'offer', 'inspection', 'closing', 'complete'];
        const stageLabels = {
          lead: 'Initial Lead',
          discover: 'Discovery Call',
          onboard: 'Client Onboard',
          research: 'Market Research',
          offer: 'Make Offer',
          inspection: 'Home Inspection',
          closing: 'Closing Process',
          complete: 'Deal Complete'
        };

        let currentStage = null;
        let currentNote = null;

        // Find the furthest non-null stage
        for (let i = stages.length - 1; i >= 0; i--) {
          const stage = stages[i];
          if (data[stage] !== null) {
            currentStage = stage;
            currentNote = data[`${stage}Note`];
            break;
          }
        }

        let statusMessage;
        if (currentStage) {
          const stageLabel = stageLabels[currentStage];
          const status = data[currentStage];
          statusMessage = `🏠 **Current Status: ${stageLabel}**\n\n📊 Status: ${status}`;
          if (currentNote) {
            statusMessage += `\n📝 Note: ${currentNote}`;
          }
        } else {
          statusMessage = '🏠 **Your Progress**\n\nNo progress recorded yet. Contact us to get started!';
        }

        const botMessage = { type: 'bot', content: statusMessage };
        setMessages(prev => [...prev, botMessage]);
      } else {
        const botMessage = { type: 'bot', content: 'No progress information found. Contact us to get started with your real estate journey!' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Error fetching CRM data:', error);
      const botMessage = { type: 'bot', content: 'Unable to retrieve your progress at this time. Please try again later.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const fetchLikedProperties = async () => {
    const userEmail = user?.email || email;
    if (!userEmail) {
      const botMessage = { type: 'bot', content: 'Please sign in to view your liked properties.' };
      setMessages(prev => [...prev, botMessage]);
      return;
    }

    try {
      const response = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/interested-buy?email=${encodeURIComponent(userEmail)}`, {
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        const likedData = await response.json();
        if (likedData.length === 0) {
          const botMessage = { type: 'bot', content: 'You haven\'t liked any properties yet.' };
          setMessages(prev => [...prev, botMessage]);
          return;
        }

        const listingKeys = likedData.map(item => item.listingKey);
        const propertiesPromises = listingKeys.map(key =>
          propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${key}`, {}).then(res => res.json())
        );

        const propertiesResults = await Promise.all(propertiesPromises);
        const likedProperties = propertiesResults
          .map(result => result.properties?.[0])
          .filter(prop => prop);

        if (likedProperties.length > 0) {
          const propertiesMessage = {
            type: 'bot',
            content: 'properties',
            properties: likedProperties,
            currentPage: 0
          };
          setMessages(prev => [...prev, propertiesMessage]);
        }
      }
    } catch (error) {
      console.error('Error fetching liked properties:', error);
      const botMessage = { type: 'bot', content: 'Unable to retrieve your liked properties at this time.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const handleAction = async (action, params = {}) => {
    // Close any existing forms first
    setShowRegistration(false);
    setShowLogin(false);

    if (action === 'show_registration') {
      setRegEmail(params.email || '');
      setRegName(params.name || '');
      setShowRegistration(true);
    } else if (action === 'show_login') {
      setLoginUsername(params.email || '');
      setShowLogin(true);
    } else if (action === 'show_map') {
      setShowProperties(true);
      return fetchProperties(params);
    } else if (action === 'collecting_buyer_info') {
      // Clarification does not start a property search.
      return;
    } else if (action === 'get_liked_properties') {
      fetchLikedProperties();
    } else if (action === 'seller_inquiry') {
      const userEmail = user?.email || email;
      const userName = user?.username || name;
      const userPhone = user?.phoneNumber || phoneNumber;

      if (userName && userPhone && userEmail) {
        submitSellerInquiry(params, userEmail, userName, userPhone);
      } else {
        setPendingSellerParams(params);
        setMessages(prev => [...prev, { type: 'bot', content: 'seller_lead_capture' }]);
        setTimeout(scrollToBottom, 200);
      }
    } else if (action === 'buying_inquiry') {
      if (!(user || chatLeadSubmitted)) {
        setPendingBuyerParams(params);
        setMessages(prev => [...prev, { type: 'bot', content: 'buyer_lead_capture' }]);
        setTimeout(scrollToBottom, 200);
      }
    } else if (action === 'storeConvo') {
      storeConversation(params);
    } else if (action === 'get-crm') {
      handleGetCRM();
    } else if (action === 'agent_contact_request') {
      // Send SMS to agent

      const userName = user?.username || name;
      const userPhone = user?.phoneNumber || phoneNumber;

      if (userName && userPhone) {
        sendAgentSMS(userName, userPhone);
      }
    }
  };

  const handleRegistrationSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://tophamtechbe.com/api/treas/auth/signup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: regName,
          email: regEmail,
          password: regPassword,
          phoneNumber: regPhoneNumber,
          name: regFullName,
          siteId: SITE_CONFIG.SITE_ID
        })
      });

      if (response.ok) {
        // Registration successful, now sign them in automatically
        try {
          const signInResponse = await fetch('https://tophamtechbe.com/api/treas/auth/signin', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              username: regName,
              password: regPassword,
              siteId: SITE_CONFIG.SITE_ID
            })
          });

          if (signInResponse.ok) {
            const userData = await signInResponse.json();
            setUser(userData);
            setIsAdmin(userData.roles?.includes('ROLE_ADMIN') || false);
            localStorage.setItem('user', JSON.stringify(userData));

            const botMessage = { type: 'bot', content: 'Registration successful! You are now signed in. How can I help you today?' };
            setMessages(prev => [...prev, botMessage]);
          } else {
            const botMessage = { type: 'bot', content: 'Registration successful! Please sign in with your new credentials.' };
            setMessages(prev => [...prev, botMessage]);
            setShowLogin(true);
          }
        } catch (error) {
          console.error('Auto sign-in error:', error);
          const botMessage = { type: 'bot', content: 'Registration successful! Please sign in with your new credentials.' };
          setMessages(prev => [...prev, botMessage]);
          setShowLogin(true);
        }

        setShowRegistration(false);
        setRegEmail('');
        setRegName('');
        setRegPassword('');
        setRegPhoneNumber('');
        setRegFullName('');
        setShowThankYouMessage(true); // Unlock send button
      } else {
        const errorData = await response.text();
        console.log('Registration error response:', errorData);
        const botMessage = { type: 'bot', content: 'Registration failed. Please try again.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Registration error:', error);
      const botMessage = { type: 'bot', content: 'Registration failed. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://tophamtechbe.com/api/treas/auth/signin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: loginUsername,
          password: loginPassword,
          siteId: SITE_CONFIG.SITE_ID
        })
      });

      if (response.ok) {
        const userData = await response.json();

        // Check if siteId matches
        if (userData.siteId?.toLowerCase() !== SITE_CONFIG.SITE_ID.toLowerCase()) {
          const botMessage = { type: 'bot', content: 'Access denied. You are not authorized for this site.' };
          setMessages(prev => [...prev, botMessage]);
          return;
        }

        // Set user data and check for admin role
        setUser(userData);
        setIsAdmin(userData.roles?.includes('ROLE_ADMIN') || false);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('user', JSON.stringify(userData));

        const botMessage = { type: 'bot', content: 'Login successful! Welcome back. How can I help you today?' };
        setMessages(prev => [...prev, botMessage]);
        setShowLogin(false);
        setLoginUsername('');
        setLoginPassword('');
        setShowThankYouMessage(true); // Unlock send button
      } else {
        const errorData = await response.text();
        console.log('Login error response:', errorData);
        const botMessage = { type: 'bot', content: 'Login failed. Please check your credentials.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Login error:', error);
      const botMessage = { type: 'bot', content: 'Login failed. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://tophamtechbe.com/api/treas/auth/password-reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: resetEmail,
          baseUrl: window.location.origin,
          siteId: SITE_CONFIG.SITE_ID
        })
      });

      if (response.ok) {
        const botMessage = { type: 'bot', content: 'Password reset link sent to your email. Please check your inbox.' };
        setMessages(prev => [...prev, botMessage]);
        setShowForgotPassword(false);
        setShowLogin(false);
        setResetEmail('');
      } else {
        const botMessage = { type: 'bot', content: 'Failed to send reset link. Please try again.' };
        setMessages(prev => [...prev, botMessage]);
      }
    } catch (error) {
      console.error('Password reset error:', error);
      const botMessage = { type: 'bot', content: 'Failed to send reset link. Please try again.' };
      setMessages(prev => [...prev, botMessage]);
    }
  };

  const fetchProperties = async (params) => {
    chatAbortRef.current?.abort();const controller=new AbortController();chatAbortRef.current=controller;
    const snapshot = chatSearchSnapshot(params, SITE_CONFIG.STATE);
    const generation = chatGenerationRef.current;
    const requestId = ++chatPropertyRequestRef.current;
    const isCurrent = () => generation === chatGenerationRef.current && requestId === chatPropertyRequestRef.current;
    setIsPropertySearching(true);
    try {
      const result = await loadPropertyPage({
        pageSize:itemsPerPage,queryOptions:{firstPhoto:true},signal:controller.signal,
        params: snapshot,
        siteId: SITE_CONFIG.SITE_ID,
        idxApiKey: "treas-api-key-2025",
        privateApiKey: 'treas-api-key-2025'
      });
      if (!isCurrent()) return;
      // Replace the entire prior search. Merging would resurrect removed filters.
      chatSearchContextRef.current = { siteId: chatSiteId, params: snapshot };
      setProperties(result.properties);
      setMessages(prev => [...prev, {
        type: 'bot',
        content: 'properties',
        properties: result.properties,
        privateUnavailable: result.privateUnavailable,
        pageState:result.pageState,hasMore:result.hasMore,searchFilters:snapshot,searchId:requestId,
        currentPage: 0
      }]);
    } catch (error) {
      if (!isCurrent()) return;
      console.error('Error fetching chat properties:', error);
      setMessages(prev => [...prev, {
        type: 'bot',
        content: "I couldn't load the property search right now. " + (error.message || "Please try again.")
      }]);
    } finally {
      if (isCurrent()) setIsPropertySearching(false);
    }
  };

  const getTileCoords = (lat, lon, zoom) => {
    const x = Math.floor((lon + 180) / 360 * Math.pow(2, zoom));
    const y = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom));
    return { x, y };
  };

  const getPropertyCoords = (property) => {
    // Use actual lat/lon from property data, fallback to Austin coordinates
    const lat = property.latitude || 30.2672;
    const lon = property.longitude || -97.7431;
    return { lat, lon };
  };

  const persistFavoriteKeys = (favoriteKeys) => {
    try {
      writeSaveStorage(localFavoritesKey, [...favoriteKeys]);
    } catch (error) {
      // CRM saving remains authoritative if browser storage is unavailable.
    }
  };

const additionalFilterCount = [
    propertySubType, maxBedrooms, minSqft, maxSqft, stories, foundation,
    minYearBuilt, maxYearBuilt, schoolDistrict, listingKey, acreage,
    minBathrooms, maxBathrooms, hasFence, hasPool, showAgentListings,
    priceSort, listingDateSort, ...communityFeatures
  ].filter(Boolean).length + Object.entries(advancedFilters).filter(([key, value]) =>
    key !== 'state' && value !== null && value !== undefined && value !== '' &&
    (!Array.isArray(value) || value.length > 0)
  ).length;
  useEffect(() => {
    if (!globeMap?.isSavedHomes) return;
    const list=globeMap.savedListId ? collections.find(row=>row.id===globeMap.savedListId) : null;
    const activeKeys=new Set((globeMap.savedListId ? list?.listingKeys || [] : [...likedProperties]).map(String));
    const properties=globeMap.properties.filter(property=>activeKeys.has(String(property.listing_key)));
    if(properties.length===globeMap.properties.length)return;
    if(!properties.length){setPropertyDetail(null);setGlobeMap(null);setMapView(true);window.history.replaceState(null,'','/search');return;}
    setGlobeMap(current=>({...current,properties}));
  },[likedProperties,collections]); // eslint-disable-line react-hooks/exhaustive-deps -- saved membership changes prune this view
  const handleViewSavedHomes = async (listKeys, listName, listId, editingListId) => {
    if (savedHomesLoading || (listKeys ? !listKeys.length : likedProperties.size === 0)) return;

    setSavedHomesLoading(true);
    setSavedHomesError('');
    const savedKeys = [...(listKeys || likedProperties)].filter(Boolean);
    let lookupFailed = false;

    try {
      const publicKeys = savedKeys.filter((key) => !String(key).startsWith('PRIVATE_'));
      const privateKeys = new Set(savedKeys.filter((key) => String(key).startsWith('PRIVATE_')).map(String));

      const publicProperties = await Promise.all(publicKeys.map(async (key) => {
        try {
          const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${encodeURIComponent(key)}`);
          if (!response.ok) {
            if (response.status >= 500 || response.status === 429) lookupFailed = true;
            return null;
          }
          const data = await response.json();
          const property = data.properties?.[0];
          return property ? { ...property, listing_key: property.listing_key || key } : null;
        } catch (error) {
          lookupFailed = true;
          return null;
        }
      }));

      let privateProperties = [];
      if (privateKeys.size > 0) {
        try {
          const response = await fetch(`https://tophamtechbe.com/api/treas/private/v1/listings?site_id=${SITE_CONFIG.SITE_ID}`, {
            headers: { 'x-api-key': 'treas-api-key-2025' }
          });
          if (!response.ok) {
            lookupFailed = true;
          } else {
            const data = await response.json();
            privateProperties = (data.listings || [])
              .map((listing) => ({
                ...listing,
                listing_key: `PRIVATE_${listing.id}`,
                current_price: listing.listing_type === 'sale' ? listing.price_sale : listing.price_lease_monthly,
                bedrooms_total: listing.beds,
                address: `${listing.address_line_1}, ${listing.city}, ${listing.state_province}`,
                isPrivate: true
              }))
              .filter((property) => privateKeys.has(String(property.listing_key)));
          }
        } catch (error) {
          lookupFailed = true;
        }
      }

      const savedProperties = [...publicProperties.filter(Boolean), ...privateProperties];
      if (savedProperties.length === 0) {
        if (lookupFailed || listKeys) {
          setSavedHomesError('Saved homes could not be loaded right now. Please try again.');
        } else {
          const emptyFavorites = new Set();
          setLikedProperties(emptyFavorites);
          persistFavoriteKeys(emptyFavorites);
        }
        return;
      }

      if (!lookupFailed && !listKeys) {
        const activeKeys = new Set(savedProperties.map((property) => property.listing_key));
        setLikedProperties(activeKeys);
        persistFavoriteKeys(activeKeys);
      }

      const mappableProperties = savedProperties.filter((property) => property.latitude && property.longitude);
      const center = mappableProperties.length > 0
        ? {
            lat: mappableProperties.reduce((sum, property) => sum + Number(property.latitude), 0) / mappableProperties.length,
            lon: mappableProperties.reduce((sum, property) => sum + Number(property.longitude), 0) / mappableProperties.length
          }
        : {
            lat: Number(SITE_CONFIG.LATITUDE) || 30.2672,
            lon: Number(SITE_CONFIG.LONGITUDE) || -97.7431
          };

      setListViewPage(0);
      setMapView(false);


      setGlobeMap({
        center,
        location: listName || 'Saved homes',
        savedListId: listId || null,
        editingListId: editingListId || null,
        properties: savedProperties,
        searchFilters: {},
        isSavedHomes: true
      });
      window.history.replaceState(null, '', '/search?saved=true');
    } catch (error) {
      setSavedHomesError('Saved homes could not be loaded right now. Please try again.');
    } finally {
      setSavedHomesLoading(false);
    }
  };

  const handleGlobeMapSubmit = async e=>{e.preventDefault();if(isGlobeMapLoading||(!locationInput.trim()&&!listingKey))return;setIsGlobeMapLoading(true);try{await fetchPropertiesForGlobe(locationInput.trim());}finally{setIsGlobeMapLoading(false);}};

  // Restore complete shared criteria on the first request, before state setters settle.
  useEffect(() => {
    const query = new URLSearchParams(initialSearchQueryRef.current);
    const initialFilters = searchFromQuery(query);
    if (!isGlobeMap || directListingKey || !Object.keys(initialFilters).length) return;
    // React StrictMode cancels the first request; restore its criteria for the retry.
    sharedSearchRef.current = initialFilters;
    const place = query.get('location') || query.get('q') || query.get('city') || query.get('zip') || query.get('state') || SITE_CONFIG.STATE;
    setLocationInput(place);
    if (query.get('view') === 'filters') return;
    fetchPropertiesForGlobe(place, query.get('searchLens') === 'true');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGlobeMap, directListingKey]);

  const loadMapPreview = (property) => {
    const key=property.listing_key;
    const cached=propertyImagesRef.current[key] || property.first_photo_url;
    if(cached || !key)return Promise.resolve(cached || null);
    if(!mapPreviewRequestsRef.current.has(key)) {
      const request=fetchPropertyImage(key).finally(()=>mapPreviewRequestsRef.current.delete(key));
      mapPreviewRequestsRef.current.set(key,request);
    }
    return mapPreviewRequestsRef.current.get(key);
  };

  const fetchPropertiesForGlobe = async (location) => {
    const request=++initialMapRequestRef.current;initialMapAbortRef.current?.abort();const controller=new AbortController();initialMapAbortRef.current=controller;setMapStats({});setLensMapData(null);
    try {
      const queryParams = new URLSearchParams();

      // Check if it's a zip code (5 digits) or city/state
      if (/^\d{5}$/.test(location.trim())) {
        queryParams.append('zip', location.trim());
      } else if (location.length === 2) {
        queryParams.append('state', location.toUpperCase());
      } else {
        // Check if it's a full state name
        const stateMap = {
          'alabama': 'AL', 'alaska': 'AK', 'arizona': 'AZ', 'arkansas': 'AR', 'california': 'CA',
          'colorado': 'CO', 'connecticut': 'CT', 'delaware': 'DE', 'florida': 'FL', 'georgia': 'GA',
          'hawaii': 'HI', 'idaho': 'ID', 'illinois': 'IL', 'indiana': 'IN', 'iowa': 'IA',
          'kansas': 'KS', 'kentucky': 'KY', 'louisiana': 'LA', 'maine': 'ME', 'maryland': 'MD',
          'massachusetts': 'MA', 'michigan': 'MI', 'minnesota': 'MN', 'mississippi': 'MS', 'missouri': 'MO',
          'montana': 'MT', 'nebraska': 'NE', 'nevada': 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
          'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', 'ohio': 'OH',
          'oklahoma': 'OK', 'oregon': 'OR', 'pennsylvania': 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
          'south dakota': 'SD', 'tennessee': 'TN', 'texas': 'TX', 'utah': 'UT', 'vermont': 'VT',
          'virginia': 'VA', 'washington': 'WA', 'west virginia': 'WV', 'wisconsin': 'WI', 'wyoming': 'WY'
        };

        const stateAbbr = stateMap[location.toLowerCase().trim()];
        if (stateAbbr) {
          queryParams.append('state', stateAbbr);
        } else {
          queryParams.append('city', location);
        }
      }

      // Add filters
      if (propertyType) queryParams.append('propertyType', propertyType);
      if (propertySubType) queryParams.append('propertySubType', propertySubType);
      if (minBedrooms) queryParams.append('minBedrooms', minBedrooms);
      if (maxBedrooms) queryParams.append('maxBedrooms', maxBedrooms);
      if (minPrice) queryParams.append('minPrice', minPrice);
      if (maxPrice) queryParams.append('maxPrice', maxPrice);
      if (minSqft) queryParams.append('minSqft', minSqft);
      if (maxSqft) queryParams.append('maxSqft', maxSqft);
      if (stories) queryParams.append('stories', stories);
      if (minYearBuilt) queryParams.append('minYearBuilt', minYearBuilt);
      if (maxYearBuilt) queryParams.append('maxYearBuilt', maxYearBuilt);
      if (hasFence) queryParams.append('hasFence', 'true');
      if (foundation) queryParams.append('foundation', foundation);
      if (schoolDistrict) queryParams.append('schoolDistrict', schoolDistrict);
      if (priceSort) queryParams.append('priceSort', priceSort);
      if (listingDateSort) queryParams.append('listingDateSort', listingDateSort);
      if (showAgentListings) queryParams.append('listAgentMlsId', SITE_CONFIG.AGENT.MLS_ID);
      if (hasMedia) queryParams.append('hasMedia', 'true');

      // Always override state with SITE_CONFIG.STATE
      queryParams.set('state', SITE_CONFIG.STATE);

      applyManualFilters(queryParams);
      const filters=searchFromQuery(queryParams);appliedSearchRef.current=filters;
      const shareParams=searchQuery(filters);if(location)shareParams.set('location',location);

      const [result,privateResult]=await Promise.all([
        loadPropertyMap({params:filters,zoom:4,signal:controller.signal}),
        loadPrivateMapRows({params:filters,siteId:SITE_CONFIG.SITE_ID,privateApiKey:'treas-api-key-2025',signal:controller.signal})]);
      if(request!==initialMapRequestRef.current)return;
      const point=result.map.features[0];
      const center=point?{lat:Number(point.latitude),lon:Number(point.longitude)}:{lat:Number(SITE_CONFIG.LOCATION?.LATITUDE)||30,lon:Number(SITE_CONFIG.LOCATION?.LONGITUDE)||-97};
      setMapView(true);setGlobeMap({center,location,properties:[],mapData:result.map,privateRows:privateResult.properties,privateUnavailable:privateResult.privateUnavailable,searchParams:filters});
      setMapStats({count:result.map.match_count,loading:false,error:''});setMapView(true);setListViewPage(0);
      if(new URLSearchParams(window.location.search).get('view') === 'map')shareParams.set('view','map');
      window.history.replaceState(window.history.state,'',`/search?${shareParams}`);
    } catch (error) {
      if(error.name==='AbortError'||request!==initialMapRequestRef.current)return;
      console.error('Error fetching properties for globe:', error);
      setManualSearchError(error.message || 'Unable to load property search.');
    }
  };

  useEffect(() => {
    let detachBoundedMap;
    if (globeMap && globeMapRef.current && mapView) {
      if (globeLeafletRef.current) {
        globeLeafletRef.current.remove();
      }

      const map = L.map(globeMapRef.current,{minZoom:1,maxZoom:20}).setView([globeMap.center.lat, globeMap.center.lon], 12);

      addIllustratedBasemap(map);
      map.zoomControl.setPosition('bottomleft');
      if(globeMap.mapData){
        const pane=map.createPane('searchLensPreviewPane');pane.classList.add('search-lens-preview-pane');pane.style.zIndex='10050';pane.style.pointerEvents='none';
        detachBoundedMap=attachBoundedMap(map,{params:globeMap.searchParams,initialMap:globeMap.mapData,privateRows:globeMap.privateRows,getPreview:loadMapPreview,onProperty:p=>p.isPrivate?fetchPrivatePropertyDetail(p):fetchPropertyDetail(p.id,p),onStatus:value=>setMapStats(prev=>({...prev,...value}))});
      }else {

      // Add property markers with clustering
      if (globeMap.properties && globeMap.properties.length > 0) {
        const markers = L.markerClusterGroup({
          maxClusterRadius: 50,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: false,
          zoomToBoundsOnClick: true
        , iconCreateFunction: cluster => clusterBubbleIcon(cluster.getChildCount())});

        globeMap.properties.forEach(property => {
          if (property.latitude && property.longitude) {
            const price = property.list_price || property.current_price || property.price;
            const priceLabel = price ? `$${Number(price).toLocaleString()}` : 'N/A';
            const pillWidth = price ? Math.max(70, priceLabel.length * 7) : 40;
            const houseIcon = propertyMapIcon(property.current_price ?? property.price,{isPrivate:property.isPrivate});

            const marker = L.marker([property.latitude, property.longitude], { icon: houseIcon });

            // Debounced hover thumbnail tooltip
            let hoverTimeout = null;
            marker.on('mouseover', function () {
              hoverTimeout = setTimeout(async () => {
                if (marker.getTooltip()) return;
                const listingKey = property.listing_key;
                const cachedImg = propertyImages[listingKey];
                const imgUrl = cachedImg || (listingKey && !property.isPrivate ? await fetchPropertyImage(listingKey) : null);
                if (imgUrl) {
                  marker.bindTooltip(
                    `<img src="${imgUrl}" alt="property" style="width:150px;height:100px;object-fit:cover;border-radius:6px;display:block;" />`,
                    { direction: 'top', offset: [0, -14], className: 'property-thumb-tooltip', permanent: false }
                  ).openTooltip();
                }
              }, 200);
            });

            marker.on('mouseout', function () {
              if (hoverTimeout) { clearTimeout(hoverTimeout); hoverTimeout = null; }
              marker.unbindTooltip();
            });

            marker.on('click', () => {
              if (property.isPrivate) {
                fetchPrivatePropertyDetail(property);
              } else if (property.id) {
                fetchPropertyDetail(property.id, property);
              }
            });

            markers.addLayer(marker);
          }
        });

        map.addLayer(markers);

      } else {
        // Add location marker if no properties
        const locationIcon = L.divIcon({
          html: '📍',
          className: 'location-marker',
          iconSize: [30, 30],
          iconAnchor: [15, 15]
        });

        L.marker([globeMap.center.lat, globeMap.center.lon], { icon: locationIcon })
          .addTo(map)
          .bindPopup(`<b>${globeMap.location}</b>`);
      }

      }
      globeLeafletRef.current = map;
      setHybridMapInstance(map);
    }

    return () => {
      detachBoundedMap?.();lensAbortRef.current?.abort();
      if (globeLeafletRef.current) {
        globeLeafletRef.current.remove();
        globeLeafletRef.current = null;
        setHybridMapInstance(null);
      }
    };
  }, [globeMap, mapView]);

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setSendButtonEnabled(true);
    setTimeout(scrollToBottom, 200);
  };

  const handleShowMoreProperties = async (messageIndex) => {
    const msg=messages[messageIndex];if(!msg||msg.loadingMore)return;
    if(msg.restartSearch){await fetchProperties(msg.searchFilters);return;}
    const nextPage=(msg.currentPage||0)+1;
    if(!msg.pageState||nextPage*itemsPerPage<msg.properties.length) {
      setMessages(prev=>prev.map((item,index)=>index===messageIndex?{...item,currentPage:nextPage}:item));return;
    }
    if(!msg.hasMore||moreRequestsRef.current.has(msg.searchId))return;
    const generation=chatGenerationRef.current;const controller=new AbortController();moreRequestsRef.current.set(msg.searchId,controller);
    const update=change=>setMessages(prev=>prev.map(item=>item.searchId===msg.searchId&&item.content==='properties'?{...item,...change}:item));
    update({loadingMore:true,pageError:''});
    try {
      const result=await loadPropertyPage({params:msg.searchFilters,pageState:msg.pageState,signal:controller.signal,pageSize:itemsPerPage,siteId:SITE_CONFIG.SITE_ID,queryOptions:{firstPhoto:true},privateApiKey:'treas-api-key-2025'});
      if(generation!==chatGenerationRef.current)return;
      const seen=new Set(msg.properties.map(p=>p.listing_key));
      update({properties:[...msg.properties,...result.properties.filter(p=>!seen.has(p.listing_key))],pageState:result.pageState,hasMore:result.hasMore,currentPage:nextPage,loadingMore:false});
    }catch(error){if(generation===chatGenerationRef.current&&error.name!=='AbortError')update({loadingMore:false,pageError:error.message,restartSearch:error.restartSearch});}
    finally{moreRequestsRef.current.delete(msg.searchId);}
  };

  const handleAiStaging = async (type) => {
    setStagingLoading(true);
    try {
      // Get random prompt for the selected type
      const promptResponse = await fetch(`https://tophamtechbeb.com/api/stage/v1/${type}-prompts/random`, {
        headers: { 'X-API-Key': 'treas-api-key-2025' }
      });

      if (!promptResponse.ok) {
        throw new Error('Failed to get staging prompt');
      }

      const promptData = await promptResponse.json();

      // Create form data with S3 URL
      const formData = new FormData();
      formData.append('image_url', enlargedImage);
      formData.append('design_prompt', promptData.prompt);

      // Call staging API
      const stagingResponse = await fetch('https://tophamtechbeb.com/api/stage/v1/stage-room', {
        method: 'POST',
        headers: { 'X-API-Key': 'treas-api-key-2025' },
        body: formData
      });

      if (!stagingResponse.ok) {
        throw new Error('Failed to stage room');
      }

      // Get staged image as blob and convert to URL
      const stagedBlob = await stagingResponse.blob();
      const imageUrl = URL.createObjectURL(stagedBlob);
      setStagingImage(imageUrl);
      setShowAiStaging(false);

    } catch (error) {
      console.error('Error staging room:', error);
      alert('Failed to stage room. Please try again.');
    } finally {
      setStagingLoading(false);
    }
  };

  const handleSellerLeadCaptureSubmit = async (e) => {
    e.preventDefault();
    setShowSellerLeadCapture(false);
    setChatLeadSubmitted(true);
    if (!isHoneypotSubmission(e.currentTarget)) await submitSellerInquiry(pendingSellerParams, email, name, phoneNumber);
    setPendingSellerParams(null);
    const botMessage = { type: 'bot', content: `Thanks ${name}! We've noted your property details and will be in touch shortly.` };
    setMessages(prev => [...prev, botMessage]);
    setTimeout(scrollToBottom, 200);
  };

  const handleBuyerLeadCaptureSubmit = async (e) => {
    e.preventDefault();
    const area = pendingBuyerParams?.city || locationInput || '';
    const zip = pendingBuyerParams?.zip || (locationInput.match(/^\d{5}$/) ? locationInput : '');
    const queryParams = new URLSearchParams({
      name,
      email,
      phoneNumber,
      serviceReq: 'buying',
      siteId: SITE_CONFIG.SITE_ID
    });
    if (area && !zip) queryParams.append('area', area);
    if (zip) queryParams.append('postalCode', zip);

    try {
      if (!isHoneypotSubmission(e.currentTarget)) await submitChatLead(new URL(`https://tophamtechbe.com/api/treas/idx/v1/chatleads?${queryParams}`).searchParams, { rememberContact: true });
    } catch (error) {
      console.error('Error submitting buyer lead:', error);
    }

    localStorage.setItem('chatLead', JSON.stringify({ name, email, phoneNumber }));
    setChatLeadSubmitted(true);

    const mergedParams = { ...pendingBuyerParams, state: SITE_CONFIG.STATE };
    if (!mergedParams.city && !mergedParams.zip && locationInput) {
      if (/^\d{5}$/.test(locationInput)) mergedParams.zip = locationInput;
      else mergedParams.city = locationInput;
    }
    if (!mergedParams.maxPrice && maxPrice) mergedParams.maxPrice = maxPrice;

    setPendingBuyerParams(null);
    setLocationInput('');
    fetchProperties(mergedParams);
    setShowProperties(true);

    const botMessage = { type: 'bot', content: `Thanks ${name}! Here are properties matching your criteria:` };
    setMessages(prev => [...prev, botMessage]);
    setTimeout(scrollToBottom, 200);
  };

  const handleSellingFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = isHoneypotSubmission(e.currentTarget) ? { ok: true } : await fetch(`https://tophamtechbe.com/api/treas/idx/v1/selling-details?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&phoneNumber=${encodeURIComponent(phoneNumber)}&address=${encodeURIComponent(propertyLocation)}&size=${encodeURIComponent(propertySize)}&condition=${encodeURIComponent(propertyCondition)}&timeline=${encodeURIComponent(sellingTimeline)}&siteId=${SITE_CONFIG.SITE_ID}`, {
        method: 'POST',
        headers: {
          'X-API-Key': 'treas-api-key-2025'
        }
      });

      if (response.ok) {
        console.log('Selling details submitted successfully');
      } else {
        console.error('Failed to submit selling details');
      }
    } catch (error) {
      console.error('Error submitting selling details:', error);
    }

    // Show completion message
    const botMessage = { type: 'bot', content: `Thank you! I have all the details about your property. David Hamady will contact you soon to discuss selling your ${propertySize} property in ${propertyLocation}.` };
    setMessages(prev => [...prev, botMessage]);
    setTimeout(scrollToBottom, 200);

    // Clear selling form but keep chat enabled
    setPropertyLocation('');
    setPropertySize('');
    setPropertyCondition('');
    setSellingTimeline('');
    // Don't set showThankYouMessage to false - keep send button enabled
  };

  const fetchPrivatePropertyDetail = async (listing) => {
    setPropertyDetailImages([]);
    setImagesLoading(true);

    const listingId = String(listing.listing_key).replace('PRIVATE_', '');

    // If listing data is incomplete (e.g. coming from a direct URL), fetch it first
    let fullListing = listing;
    if (!listing.current_price && !listing.address) {
      try {
        const detailResponse = await fetch(`https://tophamtechbe.com/api/treas/private/v1/listing/${listingId}?site_id=${SITE_CONFIG.SITE_ID}`, {
          headers: { 'x-api-key': 'treas-api-key-2025' }
        });
        if (detailResponse.ok) {
          const detailData = await detailResponse.json();
          const d = detailData.listing || detailData;
          fullListing = {
            ...d,
            listing_key: `PRIVATE_${d.id}`,
            current_price: d.listing_type === 'sale' ? d.price_sale : d.price_lease_monthly,
            bedrooms_total: d.beds,
            address: `${d.address_line_1}, ${d.city}, ${d.state_province}`,
            isPrivate: true
          };
        }
      } catch (error) {
        console.error('Error fetching private listing detail:', error);
      }
    }

    try {
      const mediaResponse = await fetch(`https://tophamtechbe.com/api/treas/media/private/v1/media/${SITE_CONFIG.SITE_ID}/${listingId}`, {
        headers: { 'x-api-key': 'treas-api-key-2025' }
      });

      if (mediaResponse.ok) {
        const mediaData = await mediaResponse.json();
        const sorted = (mediaData.media || []).sort((a, b) => a.order_hint - b.order_hint);
        setPropertyDetailImages(sorted.map(img => img.s3_link));
      }
    } catch (error) {
      console.error('Error fetching private property media:', error);
    } finally {
      setImagesLoading(false);
    }

    const address = fullListing.address || '';
    setPropertyDetail({
      ...fullListing,
      listing_key: fullListing.listing_key,
      current_price: fullListing.current_price,
      bedrooms_total: fullListing.bedrooms_total,
      created_at: fullListing.created_at,
      updated_at: fullListing.updated_at,
      location: {
        street_number: address.split(',')[0] || '',
        city: fullListing.city || '',
        state: fullListing.state_province || '',
        postal_code: fullListing.postal_code || ''
      },
      features: {
        public_remarks: fullListing.description || ''
      },
      isPrivate: true
    });
  };

  const fetchPropertyDetail = async (propertyId, summaryData) => {
    const requestId = ++detailRequestRef.current;
    const cover = summaryData?.first_photo_url || summaryData?.image_url || summaryData?.photo_url;
    setPropertyDetail(summaryData || null);
    setPropertyDetailImages(cover ? [cover] : []);
    setImagesLoading(!cover);

    try {
      const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-data/${propertyId}`, {});
      if (requestId !== detailRequestRef.current) return;

      if (response.ok) {
        const data = await response.json();
        const property = data.properties[0];
        setPropertyDetail({
          ...property,
          created_at: property.created_at || summaryData?.created_at,
          updated_at: property.updated_at || summaryData?.updated_at
        });

        // Fetch all images for the property detail view
        if (property.listing_key) {
          fetchAllPropertyImages(property.listing_key, requestId, cover);
        }
      } else {
        console.error('Failed to fetch property details');
        setImagesLoading(false);
      }
    } catch (error) {
      console.error('Error fetching property details:', error);
      if (requestId === detailRequestRef.current) setImagesLoading(false);
    }
  };

  const fetchPropertyDetailByListingKey = async (listingKey) => {
    if (String(listingKey).startsWith('PRIVATE_')) {
      fetchPrivatePropertyDetail({ listing_key: listingKey });
      return;
    }
    try {
      const response = await propertyFetch(`https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-summary?listingKey=${listingKey}`, {});

      if (response.ok) {
        const data = await response.json();
        const properties = data.properties || [];
        if (properties.length > 0) {
          const property = properties[0];
          // Fetch full details using property ID
          if (property.id) {
            fetchPropertyDetail(property.id, property);
          }
        } else {
          console.error('No property found for listing key:', listingKey);
          alert('Property not found. Please check the listing key.');
        }
      } else {
        console.error('Failed to fetch property by listing key');
        alert('Failed to load property. Please try again.');
      }
    } catch (error) {
      console.error('Error fetching property by listing key:', error);
      alert('Failed to load property. Please try again.');
    }
  };

  const fetchPropertyImage = async (listingKey) => {
    if (propertyImages[listingKey]) return propertyImages[listingKey];

    try {
      const imageUrl = propertyMediaUrls(await loadPropertyMedia(listingKey))[0];
      if (imageUrl) {
          setPropertyImages(prev => ({...prev, [listingKey]: imageUrl}));
          rememberPropertyPhoto(listingKey, imageUrl);
          return imageUrl;
      }
    } catch (error) {
      console.error('Error fetching property image:', error);
    }
    return null;
  };

  const fetchAllPropertyImages = async (listingKey, requestId = detailRequestRef.current, cover = '') => {
    try {
      const images = propertyMediaUrls(await loadPropertyMedia(listingKey));
      if (requestId !== detailRequestRef.current) return;
      if (images.length > 0) {
          const firstThree = images.slice(0, 3);
          setPropertyDetailImages(firstThree);
          setImagesLoading(false);
          rememberPropertyPhoto(listingKey, images[0]);
          if (images.length > 3) {
            setTimeout(() => {
              if (requestId === detailRequestRef.current) setPropertyDetailImages(images);
            }, 500);
          }
      } else {
        if (cover) setPropertyDetailImages([cover]);
        setImagesLoading(false);
      }
    } catch (error) {
      console.error('Error fetching all property images:', error);
      if (requestId === detailRequestRef.current) {
        if (cover) setPropertyDetailImages([cover]);
        setImagesLoading(false);
      }
    }
  };

  const closePropertyDetail = () => {
    detailRequestRef.current += 1;
    setPropertyDetail(null);
    setImagesLoading(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSecondMessage(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  if (isGlobeMap) {
    return (
      <>
        <style>{`
          @media (max-width: 1024px) {
            .list-view-card { width: calc(50% - 12px) !important; }
          }
          @media (max-width: 600px) {
            .list-view-card { width: 100% !important; }
          }
        `}</style>
      <div className={`full-page-map-container ${!globeMap?'filter-page':''} ${isDarkMode?'dark-mode':''}`}>
        {!globeMap ? (
          <div className="map-location-form">
            <button
              className="close-map-page"
              onClick={() => onGlobeMapClose()}
              aria-label="Close property search and return to main page"
            >
              ← Back to Main
            </button>
            <header className="property-search-heading"><span>Live property search</span><h2>Find the right property</h2><p>Start with a location and refine what matters. Saved-search alerts are optional after you view results.</p></header>
            {POPULAR_SEARCH_AREAS.length > 0 && (
              <div className="property-search-popular" aria-label="Popular property searches">
                <span>Popular:</span>
                {POPULAR_SEARCH_AREAS.map((area) => (
                  <button type="button" key={area} onClick={() => setLocationInput(area)}>{area}</button>
                ))}
              </div>
            )}
            {likedProperties.size > 0 && (
              <section className="property-saved-homes" aria-labelledby="saved-homes-heading">
                <span className="property-saved-homes-icon" aria-hidden="true">♥</span>
                <div>
                  <h3 id="saved-homes-heading">Your saved homes</h3>
                  <p>{likedProperties.size} {likedProperties.size === 1 ? 'property is' : 'properties are'} saved in this browser.</p>
                  {savedHomesError && <small role="alert">{savedHomesError}</small>}
                </div>
                <SavedPropertyLists onView={handleViewSavedHomes} busy={savedHomesLoading} error={savedHomesError} />
              </section>
            )}
            <form onChange={()=>{sharedSearchRef.current=null;}} id="property-search-form" onSubmit={handleGlobeMapSubmit}>
              <div className="filter-row">
                <input type="text" placeholder="Enter city, state, or zip" value={locationInput} onChange={e => setLocationInput(e.target.value)} aria-label="City, state, or ZIP code" className="location-filter-input" required={!listingKey} />
                <select aria-label="Property type" className="filter-select" value={propertyType} onChange={e => {
                  setPropertyType(e.target.value);
                  setPropertySubType('');
                }}>
                  <option value="Residential">Residential</option>
                  <option value="CommercialSale">Commercial Sale</option>
                  <option value="ResidentialLease">Residential Lease</option>
                  <option value="Land">Land</option>
                  <option value="ResidentialIncome">Residential Income</option>
                  <option value="CommercialLease">Commercial Lease</option>
                  <option value="Farm">Farm</option>
                </select>
              </div>
              <div className="filter-row">
                <input type="number" aria-label="Minimum price" placeholder="Min Price" value={minPrice} onChange={e => setMinPrice(e.target.value)} className="filter-select" />
                <input type="number" aria-label="Maximum price" placeholder="Max Price" value={maxPrice} onChange={e => setMaxPrice(e.target.value)} className="filter-select" />
              </div>
              <div className="filter-row"><select aria-label="Minimum bedrooms" className="filter-select" value={minBedrooms} onChange={e => setMinBedrooms(e.target.value)}>
                  <option value="">Min Bedrooms</option>
                  <option value="1">1+</option>
                  <option value="2">2+</option>
                  <option value="3">3+</option>
                  <option value="4">4+</option>
                </select></div>
              <SearchFilterPanel busy={isGlobeMapLoading} count={additionalFilterCount} onApply={() => document.getElementById('property-search-form')?.requestSubmit()}><div className="filter-row"><select className="filter-select" value={maxBedrooms} onChange={e => setMaxBedrooms(e.target.value)}>
                    <option value="">Max Bedrooms</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5+</option>
                  </select></div>

                <div className="filter-row">
                  <select className="filter-select" value={propertySubType} onChange={e => setPropertySubType(e.target.value)}>
                    <option value="">Any home type</option>
                    <option value="SingleFamilyResidence">Single Family</option>
                    <option value="Apartment">Apartment</option>
                    <option value="Condominium">Condominium</option>
                    <option value="Townhouse">Townhouse</option>
                    <option value="Duplex">Duplex</option>
                    <option value="Ranch">Ranch</option>
                    <option value="Other">Other</option>
                  </select>
                  <select className="filter-select" value={priceSort || (listingDateSort === 'newold' ? 'listnewold' : listingDateSort === 'oldnew' ? 'listoldnew' : '')} onChange={e => {
                    const val = e.target.value;
                    if (val === 'lowhigh' || val === 'highlow') {
                      setPriceSort(val);
                      setListingDateSort('');
                    } else if (val === 'listnewold' || val === 'listoldnew') {
                      setListingDateSort(val === 'listnewold' ? 'newold' : 'oldnew');
                      setPriceSort('');
                    }
                  }}>
                    <option value="">Sort By</option>
                    <option value="lowhigh">Price: Low to High</option>
                    <option value="highlow">Price: High to Low</option>
                    <option value="listnewold">Listed Date: Newest</option>
                    <option value="listoldnew">Listed Date: Oldest</option>
                  </select>
                </div>
                <div className="filter-row">
                  <input type="number" placeholder="Min Sq Ft" value={minSqft} onChange={e => setMinSqft(e.target.value)} className="filter-select" />
                  <input type="number" placeholder="Max Sq Ft" value={maxSqft} onChange={e => setMaxSqft(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row">
                  <input type="number" placeholder="Stories" value={stories} onChange={e => setStories(e.target.value)} className="filter-select" />
                  <select className="filter-select" value={foundation} onChange={e => setFoundation(e.target.value)}>
                    <option value="">Foundation Type</option>
                    <option value="CrawlSpace">Crawl Space</option>
                    <option value="Slab">Slab</option>
                  </select>
                </div>
                <div className="filter-row filter-year-row">
                  <input type="number" placeholder="Min Year Built" value={minYearBuilt} onChange={e => setMinYearBuilt(e.target.value)} className="filter-select" />
                  <input type="number" placeholder="Max Year Built" value={maxYearBuilt} onChange={e => setMaxYearBuilt(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row">
                  <input type="text" placeholder="School District" value={schoolDistrict} onChange={e => setSchoolDistrict(e.target.value)} className="filter-select" />
                  <input type="text" placeholder="Listing Key" value={listingKey} onChange={e => setListingKey(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row">
                  <select className="filter-select" value={acreage} onChange={e => setAcreage(e.target.value)}>
                    <option value="">Acreage</option>
                    <option value="<5">&lt; 5 Acres</option>
                    <option value="5to10">5 to 10 Acres</option>
                    <option value="10+">10+ Acres</option>
                  </select>
                  <select className="filter-select" multiple value={communityFeatures} onChange={e => setCommunityFeatures(Array.from(e.target.selectedOptions, o => o.value))}>
                    <option value="greenbelt">Greenbelt</option>
                    <option value="hill">Hill Country</option>
                    <option value="golf">Golf Course</option>
                    <option value="downtown">Downtown</option>
                    <option value="water">Water</option>
                  </select>
                </div>
                <RobustSearchControls expanded filters={advancedFilters} onChange={next => {sharedSearchRef.current=null;setAdvancedFilters(next);}} scope={{state:advancedFilters.state || SITE_CONFIG.SEARCH_STATES || SITE_CONFIG.STATE,propertyType}} />
                <div className="filter-row">
                  <input type="number" placeholder="Min Bathrooms" value={minBathrooms} onChange={e => setMinBathrooms(e.target.value)} className="filter-select" />
                  <input type="number" placeholder="Max Bathrooms" value={maxBathrooms} onChange={e => setMaxBathrooms(e.target.value)} className="filter-select" />
                </div>
                <div className="filter-row filter-toggle-row">
                  <label className="agent-toggle">
                    <input type="checkbox" checked={showAgentListings} onChange={e => setShowAgentListings(e.target.checked)} />
                              Show only {SITE_CONFIG.AGENT.NAME}'s listings
                            </label>
                  <label className="agent-toggle">
                    <input type="checkbox" checked={hasFence} onChange={e => setHasFence(e.target.checked)} />
                              Has Fencing
                            </label>
                  <label className="agent-toggle">
                    <input type="checkbox" checked={hasPool} onChange={e => setHasPool(e.target.checked)} />
                              Pool
                            </label>
                </div></SearchFilterPanel>
              {manualSearchError && <p role="alert">{manualSearchError}</p>}
              <button type="submit" className="full-page-search-btn" aria-label="Search for properties with selected filters" aria-busy={isGlobeMapLoading} disabled={isGlobeMapLoading}>
                {isGlobeMapLoading ? <><span className="property-search-spinner" aria-hidden="true" /> Loading properties…</> : 'Search Properties'}
              </button>
            </form>
            <footer className="property-search-utility">
              <span>Need help deciding where to start?</span>
              <a href="/first-time-home-buyer-flint">Explore local guides</a>
              <a href={`mailto:${SITE_CONFIG.AGENT.EMAIL}`}>Email {SITE_CONFIG.AGENT.NAME.split(' ')[0]}</a>
              <a href={`tel:${SITE_CONFIG.AGENT.PHONE}`}>Call</a>
            </footer>
          </div>
        ) : (
          <div className={["full-page-leaflet-container",mapView && hybridView ? 'hybrid-map-view' : '',mapTrayExpanded ? 'map-tray-expanded' : ''].join(' ')}>
<div className="map-workspace">
            <button
              type="button"
              className="close-map-page"
              onClick={() => {
                setEnlargedImage(null);
                setStagingImage(null);
                setPropertyDetail(null);
                setGlobeMap(null);initialMapRequestRef.current++;initialMapAbortRef.current?.abort();sessionStorage.removeItem('globeMapData');window.history.replaceState(window.history.state,'','/search');sharedSearchRef.current=null;
              }}
              aria-label="Go back to property search filters"
            >
              ← Back to Filters
            </button>
            {mapView && globeMap.mapData && (mapStats.loading||mapStats.error||globeMap.privateUnavailable) && <p className="bounded-map-status" role={mapStats.error?'alert':'status'}>{mapStats.error||(mapStats.loading?'Updating visible homes…':'Private listings are currently unavailable.')}</p>}
            {mapView && <div ref={globeMapRef} className="full-page-leaflet-map"></div>}
            {!mapView && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                padding: '80px 20px 100px 20px',
                background: isDarkMode ? 'rgb(15, 23, 42)' : '#f3f3f3',
                boxSizing: 'border-box',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                justifyContent: 'center',
                alignContent: 'flex-start'
              }}>
                  {globeMap.editingListId && <section className="saved-list-edit-heading"><h3>Add homes to {collections.find(row=>row.id===globeMap.editingListId)?.name || 'your list'}</h3><p>Check the saved homes you want in this list. Your choices are saved immediately.</p><button type="button" onClick={()=>{const list=collections.find(row=>row.id===globeMap.editingListId);if(list?.listingKeys.length)handleViewSavedHomes(list.listingKeys,list.name,list.id);else setGlobeMap(null);}}>Done</button></section>}{globeMap.properties && globeMap.properties.slice(listViewPage * 9, (listViewPage + 1) * 9).map((property, index) => {
                  const price = property.current_price || property.price;
                  const address = formatPropertyAddress(property);
                  return (
                    <div
                      key={index}
                      onClick={() => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
                      className={`list-view-card ${globeMap.isSavedHomes ? 'saved-home-card' : ''}`}
                      style={{
                        width: 'calc(33.333% - 12px)',
                        maxWidth: '400px',
                        minWidth: '260px',
                        cursor: 'pointer',
                        background: isDarkMode ? 'rgb(30, 41, 59)' : 'white',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        position: 'relative'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                      }}
                    >
                      <script type="application/ld+json">
                        {JSON.stringify({
                          "@context": "https://schema.org",
                          "@type": "RealEstateProperty",
                          "name": address,
                          "address": {
                            "@type": "PostalAddress",
                            "streetAddress": formatStreetAddress(property),
                            "addressLocality": property.city,
                            "addressRegion": property.state,
                            "postalCode": property.postal_code
                          },
                          "price": price,
                          "priceCurrency": "USD",
                          "numberOfRooms": property.bedrooms_total,
                          "floorSize": {
                            "@type": "QuantitativeValue",
                            "value": property.living_area,
                            "unitCode": "SQF"
                          },
                          "propertyType": property.property_type,
                          "image": property.first_photo_url || property.image_url || property.photo_url,
                          "url": `${window.location.origin}/listing/${property.listing_key}`
                        })}
                      </script>
                      {/* Hero image */}
                      <div style={{position: 'relative', width: '100%', paddingTop: '66%', background: isDarkMode ? 'rgb(51, 65, 85)' : '#e5e7eb'}}>
                        <PropertyThumbnail
                          listingKey={property.listing_key}
                          src={property.first_photo_url || property.image_url || property.photo_url}
                          alt={`Property at ${address}`}
                          style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover'}}
                        />
                        {/* Mini map thumbnail */}
                        {property.latitude && property.longitude && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedMap({lat: property.latitude, lon: property.longitude, address: address});
                            }}
                            style={{
                              position: 'absolute', bottom: 8, right: 8,
                              width: '72px', height: '54px',
                              borderRadius: '6px', overflow: 'hidden',
                              border: '2px solid white',
                              boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                              cursor: 'pointer'
                            }}
                          >
                            <img
                              src={`https://tile.openstreetmap.org/15/${getTileCoords(property.latitude, property.longitude, 15).x}/${getTileCoords(property.latitude, property.longitude, 15).y}.png`}
                              alt={`Map for ${address}`}
                              style={{width: '100%', height: '100%', objectFit: 'cover'}}
                            />
                            <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '16px', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.4))'}}>📍</div>
                          </div>
                        )}
                        {/* Property type badge */}
                        {property.property_type && (
                          <div style={{position: 'absolute', top: 8, left: 8, background: 'rgba(0,0,0,0.6)', color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: '600'}}>
                            {property.property_type}
                          </div>
                        )}
                      </div>
                      {/* Info section */}
                      <div style={{padding: '12px 14px'}}>
                        <div style={{fontSize: '15px', color: isDarkMode ? '#e2e8f0' : '#1e293b', fontWeight: '500', marginBottom: '6px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                          {address}
                        </div>
                        <div style={{fontSize: '20px', fontWeight: '700', color: '#0176d3'}}>
                          ${price?.toLocaleString() || 'N/A'}
                        </div>
                        {property.bedrooms_total && (
                          <div style={{fontSize: '13px', color: isDarkMode ? '#94a3b8' : '#64748b', marginTop: '4px'}}>
                            🛏️ {property.bedrooms_total} bed{property.living_area ? ` · ${Number(property.living_area).toLocaleString()} sqft` : ''}
                          </div>
                        )}
                      </div>
                    {globeMap.isSavedHomes && (globeMap.editingListId ? <PropertyListMembership listingKey={property.listing_key} listId={globeMap.editingListId}/> : <PropertyListPicker listingKey={property.listing_key}/>)}</div>
                  );
                })}
                <div style={{width: '100%', display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '24px', paddingBottom: '20px', alignItems: 'center'}}>
                  {listViewPage > 0 && (
                    <button
                      onClick={() => setListViewPage(listViewPage - 1)}
                      style={{
                        padding: '8px 16px',
                        background: 'white',
                        color: '#0176d3',
                        border: '1px solid #dddbda',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f3f3f3';
                        e.currentTarget.style.borderColor = '#0176d3';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'white';
                        e.currentTarget.style.borderColor = '#dddbda';
                      }}
                    >
                      ← Previous
                    </button>
                  )}
                  <span style={{padding: '8px 16px', fontSize: '13px', color: isDarkMode ? '#94a3b8' : '#3e3e3c', fontWeight: '400'}}>
                    Page {listViewPage + 1} of {Math.ceil(globeMap.properties.length / 9)}
                  </span>
                  {(listViewPage + 1) * 9 < globeMap.properties.length && (
                    <button
                      onClick={() => setListViewPage(listViewPage + 1)}
                      style={{
                        padding: '8px 16px',
                        background: 'white',
                        color: '#0176d3',
                        border: '1px solid #dddbda',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '600',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f3f3f3';
                        e.currentTarget.style.borderColor = '#0176d3';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'white';
                        e.currentTarget.style.borderColor = '#dddbda';
                      }}
                    >
                      Next →
                    </button>
                  )}
                </div>
              </div>
            )}
            <div className="map-toolbar map-toolbar--compact"><div className="map-info">
 <div className="map-view-switcher" role="group" aria-label="Property view">
 <button type="button" className="map-view-option" aria-pressed={!hybridView} onClick={() => {setMapView(true);setMapTrayExpanded(false);setHybridView(false);setActiveMapTool(null);}}>Map</button>
 <button type="button" className="map-view-option map-view-toggle" aria-pressed={hybridView} onClick={() => {setMapView(true);setMapTrayExpanded(false);setHybridView(true);setActiveMapTool(null);}}>Hybrid</button>
 <button type="button" className="map-view-option map-list-option" onClick={()=>{const filters={...appliedSearchRef.current,...(globeMap.mapData?mapStats.bounds:{})};navigate(`/properties/list?${searchQuery(filters)}`,{state:{user,searchFilters:filters,...(globeMap.isSavedHomes?{properties:globeMap.properties,isSavedHomes:true,savedMap:globeMap}:{})}});}}>List</button>
 </div><div className="map-tools-row"><div className="map-result-count" aria-live="polite">{globeMap.mapData?`${mapStats.count??globeMap.mapData.match_count} homes in view`:globeMap.location}</div><div className="map-tools-actions"></div></div>
 </div></div>
          </div>
<MapPlaceLayers compact compactOpen={activeMapTool === 'places'} onCompactOpenChange={setPlacesOpen} map={mapView && !propertyDetail && !expandedMap ? hybridMapInstance : null} />
{mapView && hybridView && !propertyDetail && <MapPropertyGrid favorites={favorites} onSave={property=>toggleFavorite(property,user)} map={hybridMapInstance} trayExpanded={mapTrayExpanded} onTrayToggle={()=>setMapTrayExpanded(value=>!value)} params={globeMap.searchParams || globeMap.searchFilters || {}} properties={!globeMap.mapData ? globeMap.properties : undefined} onProperty={property=>property.isPrivate?fetchPrivatePropertyDetail(property):fetchPropertyDetail(property.id,property)} />}
</div>
        )}
        {propertyDetail && (
          <div className="expanded-map-modal map-property-detail-overlay" onClick={closePropertyDetail}>
            <><FleetPropertyDetailActions home={propertyDetail} user={user} /><div className="property-detail-modal" onClick={(e) => e.stopPropagation()}>
              <script type="application/ld+json">
                {JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "RealEstateProperty",
                  "name": formatPropertyAddress(propertyDetail),
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": formatStreetAddress(propertyDetail),
                    "addressLocality": propertyDetail.location?.city,
                    "addressRegion": propertyDetail.location?.state,
                    "postalCode": propertyDetail.location?.postal_code
                  },
                  "price": propertyDetail.current_price,
                  "priceCurrency": "USD",
                  "numberOfRooms": propertyDetail.bedrooms_total,
                  "numberOfBathroomsTotal": propertyDetail.bathrooms_full + (propertyDetail.bathrooms_half || 0) * 0.5,
                  "floorSize": {
                    "@type": "QuantitativeValue",
                    "value": propertyDetail.living_area,
                    "unitCode": "SQF"
                  },
                  "propertyType": propertyDetail.property_type,
                  "yearBuilt": propertyDetail.year_built,
                  "image": propertyDetailImages,
                  "description": propertyDetail.features?.public_remarks,
                  "url": `${window.location.origin}/listing/${propertyDetail.listing_key}`
                })}
              </script>
              <button className="close-expanded-map" onClick={() => {
                if (directListingKey) {
                  closePropertyDetail();
                  navigate('/');
                } else {
                  closePropertyDetail();
                }
              }}>
                ×
              </button>
              <button
                className="link-button"
                onClick={() => {
                  const url = getPropertyShareUrl(propertyDetail, SITE_CONFIG);
                  navigator.clipboard.writeText(url).then(() => {
                    setShowCopySuccess(true);
                    setTimeout(() => setShowCopySuccess(false), 3000);
                  }).catch(err => {
                    console.error('Failed to copy:', err);
                    alert('Failed to copy link');
                  });
                }}
                aria-label="Copy property link to clipboard"
              >
                🔗
              </button>
              <button
                className={`heart-button ${likedProperties.has(propertyDetail.listing_key) ? 'liked' : ''}`}
                onClick={() => toggleFavorite(propertyDetail, user)}
                aria-label={likedProperties.has(propertyDetail.listing_key) ? "Remove property from favorites" : "Save property to favorites"}
              >
                {likedProperties.has(propertyDetail.listing_key) ? '💖' : '❤️'}
              </button>
              <div className="property-detail-content">
                <div className="property-header">
<div className={`property-overview-grid${mapCoordinates(propertyDetail) ? '' : ' property-overview-grid--no-map'}`}><div className="property-overview-summary">
                  {!propertyDetail.isPrivate && (propertyDetail.list_agent_full_name || propertyDetail.list_office_name) && (
                    <div style={{fontSize: '11px', color: '#888', marginBottom: '6px', textAlign: 'left'}}>
                      {propertyDetail.list_agent_full_name && (
                        <div>Listing Agent: {propertyDetail.list_agent_full_name}{propertyDetail.list_agent_mls_id ? ` (${propertyDetail.list_agent_mls_id})` : ''}</div>
                      )}
                      {propertyDetail.list_office_name && (
                        <div>Office: {propertyDetail.list_office_name}</div>
                      )}
                    </div>
                  )}
                  <h2>${(propertyDetail.list_price || propertyDetail.current_price)?.toLocaleString()}</h2>
                  <p className="property-address">{formatPropertyAddress(propertyDetail)}</p>


                  </div><PropertyLocationMap property={propertyDetail} /></div>
<div className="property-images">
                    {imagesLoading ? (
                      <div style={{textAlign: 'center', padding: '20px', color: '#007bff', fontSize: '14px'}}>
                        <div style={{display: 'inline-block', marginRight: '8px', animation: 'spin 1s linear infinite', fontSize: '16px'}}>⟳</div>
                        Checking for images...
                      </div>
                    ) : propertyDetailImages.length > 0 ? (
                      propertyDetailImages.map((imageUrl, index) => (
                        <div key={index} className="property-detail-image" onClick={() => { setEnlargedImage(imageUrl); setEnlargedImageIndex(index); }}>
                          <img src={imageUrl} alt={`Property ${index + 1}`} onLoad={() => rememberPropertyPhoto(propertyDetail?.listing_key, imageUrl)} />
                        </div>
                      ))
                    ) : (
                      <div style={{textAlign: 'center', padding: '20px', color: '#666', fontSize: '14px'}}>
                        No images available for this property
                      </div>
                    )}
                  </div>

                  {propertyDetail.features?.public_remarks && (
                    <div className="property-description">
                      <h3>Property Description</h3>
                      <p>{propertyDetail.features.public_remarks}</p>
                    </div>
                  )}
                </div>

                <div className="property-columns">
                  <div className="property-column">
                    <h3>Property Details</h3>
                    <p><strong>Property Type:</strong> {propertyDetail.property_type}</p>
                    {propertyDetail.property_sub_type && <p><strong>Property Sub Type:</strong> {propertyDetail.property_sub_type}</p>}
                    <p><strong>Listing Key:</strong> {propertyDetail.listing_key}</p>
                    <p><strong>List Price:</strong> ${propertyDetail.list_price?.toLocaleString()}</p>
                    {propertyDetail.original_list_price && <p><strong>Original List Price:</strong> ${propertyDetail.original_list_price?.toLocaleString()}</p>}
                    <p><strong>Living Area:</strong> {propertyDetail.living_area} sq ft</p>
                    <p><strong>Building Area:</strong> {propertyDetail.building_area_total} sq ft</p>
                    <p><strong>Year Built:</strong> {propertyDetail.year_built}</p>
                    {propertyDetail.stories && <p><strong>Stories:</strong> {propertyDetail.stories}</p>}
                    {propertyDetail.listing_contract_date && <p><strong>Listed Date:</strong> {new Date(propertyDetail.listing_contract_date).toLocaleDateString()}</p>}
                    {propertyDetail.listing_contract_date && <p><strong>Days on Market:</strong> {Math.floor((Date.now() - new Date(propertyDetail.listing_contract_date)) / 86400000)}</p>}
                    {(propertyDetail.updated_at || propertyDetail.created_at) && <p><strong>Last Updated:</strong> {new Date(propertyDetail.updated_at || propertyDetail.created_at).toLocaleString()}</p>}

                    {propertyDetail.land && (
                      <div>
                        <h3>Land Details</h3>
                        {propertyDetail.land.lot_size_acres && <p><strong>Lot Size:</strong> {propertyDetail.land.lot_size_acres} acres ({propertyDetail.land.lot_size_square_feet?.toLocaleString()} sq ft)</p>}
                        {propertyDetail.land.lot_features && <p><strong>Lot Features:</strong> {propertyDetail.land.lot_features}</p>}
                        {propertyDetail.land.zoning && <p><strong>Zoning:</strong> {propertyDetail.land.zoning}</p>}
                      </div>
                    )}

                    <h3>Rooms & Bathrooms</h3>
                    {propertyDetail.bedrooms_total != null && <p><strong>Bedrooms:</strong> {propertyDetail.bedrooms_total}</p>}
                    {propertyDetail.bathrooms_full != null && <p><strong>Full Bathrooms:</strong> {propertyDetail.bathrooms_full}</p>}
                    {propertyDetail.bathrooms_half != null && <p><strong>Half Bathrooms:</strong> {propertyDetail.bathrooms_half}</p>}
                    {propertyDetail.fireplaces_total != null && <p><strong>Fireplaces:</strong> {propertyDetail.fireplaces_total}</p>}

                    {propertyDetail.schools && (
                      <div>
                        <h3>Schools</h3>
                        <p><strong>Elementary:</strong> {propertyDetail.schools.elementary_school}</p>
                        <p><strong>Middle:</strong> {propertyDetail.schools.middle_school}</p>
                        <p><strong>High:</strong> {propertyDetail.schools.high_school}</p>
                      </div>
                    )}
                  </div>

                  <div className="property-column">
                    <h3>Features & Amenities</h3>
                    {propertyDetail.features?.garage_spaces != null && <p><strong>Garage:</strong> {propertyDetail.features.garage_spaces} spaces</p>}
                    {propertyDetail.features?.heating && <p><strong>Heating:</strong> {propertyDetail.features.heating}</p>}
                    {propertyDetail.features?.cooling && <p><strong>Cooling:</strong> {propertyDetail.features.cooling}</p>}
                    {propertyDetail.features?.water_source && <p><strong>Water Source:</strong> {propertyDetail.features.water_source}</p>}
                    {propertyDetail.foundation_details && <p><strong>Foundation:</strong> {propertyDetail.foundation_details}</p>}
                    {propertyDetail.roof && <p><strong>Roof:</strong> {propertyDetail.roof}</p>}
                    {propertyDetail.sewer && <p><strong>Sewer:</strong> {propertyDetail.sewer}</p>}

                    {propertyDetail.features?.appliances && (
                      <div>
                        <h3>Appliances</h3>
                        <p className="feature-list">{propertyDetail.features.appliances.split(',').join(', ')}</p>
                      </div>
                    )}

                    {propertyDetail.features?.interior_features && (
                      <div>
                        <h3>Interior Features</h3>
                        <p className="feature-list">{propertyDetail.features.interior_features.split(',').join(', ')}</p>
                      </div>
                    )}

                    {propertyDetail.features?.exterior_features && (
                      <div>
                        <h3>Exterior Features</h3>
                        <p className="feature-list">{propertyDetail.features.exterior_features.split(',').join(', ')}</p>
                      </div>
                    )}

                    {propertyDetail.features?.fencing && (
                      <div>
                        <h3>Fencing</h3>
                        <p>{propertyDetail.features.fencing}</p>
                      </div>
                    )}

                    {propertyDetail.association?.association_name && (
                      <div>
                        <h3>HOA Information</h3>
                        <p><strong>Association:</strong> {propertyDetail.association.association_name}</p>
                        {propertyDetail.association.association_fee && <p><strong>HOA Fee:</strong> ${propertyDetail.association.association_fee} {propertyDetail.association.fee_frequency}</p>}
                      </div>
                    )}

                    {propertyDetail.features?.lots_features && (
                      <div>
                        <h3>Lot Features</h3>
                        <p className="feature-list">{propertyDetail.features.lots_features.split(',').join(', ')}</p>
                      </div>
                    )}

                    {propertyDetail.features?.patio_and_porch_features && (
                      <div>
                        <h3>Patio & Porch</h3>
                        <p className="feature-list">{propertyDetail.features.patio_and_porch_features.split(',').join(', ')}</p>
                      </div>
                    )}
                  </div>
                </div>
                {!propertyDetail.isPrivate && (
                  <div style={{borderTop: '1px solid #ddd', marginTop: '20px', paddingTop: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'}}>
                    <img src={SITE_CONFIG.MLS.LOGO_URL} alt={SITE_CONFIG.MLS.SHORT_NAME} style={{height: '32px', objectFit: 'contain'}} />
                    <div style={{fontSize: '12px', color: '#666', flex: 1}}>
                      <span>{SITE_CONFIG.MLS.DISCLAIMER}</span>
                    </div>
                  </div>
                )}
              </div>

              {showLogin && (
                <div className="property-login-form">
                  <h3>Sign In to Express Interest</h3>
                  <form className="chat-form" onSubmit={handleLoginSubmit}>
                    <input
                      type="text"
                      placeholder="Username or Email"
                      value={loginUsername}
                      onChange={(e) => setLoginUsername(e.target.value)}
                      className="form-input"
                      required
                    />
                    <input
                      type="password"
                      placeholder="Password"
                      value={loginPassword}
                      onChange={(e) => setLoginPassword(e.target.value)}
                      className="form-input"
                      required
                    />
                    <button type="submit" className="form-submit">Sign In</button>
                    <button
                      type="button"
                      className="forgot-password-link"
                      onClick={() => { setShowLogin(false); setShowRegistration(true); }}
                    >
                      Don't have an account? Register
                    </button>
                    <button
                      type="button"
                      className="form-submit"
                      onClick={() => setShowLogin(false)}
                      style={{background: '#6c757d'}}
                    >
                      Cancel
                    </button>
                  </form>
                </div>
              )}
            </div></>
          </div>
        )}
        {enlargedImage && (
          <div className="enlarged-image-modal" onClick={() => { setEnlargedImage(null); setStagingImage(null); }}>
            <div className="enlarged-image-container" onClick={(e) => e.stopPropagation()}>
              <div className="image-wrapper">
                <button className="close-enlarged-image" onClick={() => { setEnlargedImage(null); setStagingImage(null); }}>
                  ×
                </button>
                <button className="ai-staging-button" onClick={() => setShowAiStaging(true)}>
                  🤖
                </button>
                <img src={stagingImage || enlargedImage} alt="Enlarged Property" className="enlarged-image" />
                {stagingImage && (
                  <button className="reset-staging-button" onClick={() => setStagingImage(null)}>
                    Original
                  </button>
                )}
              </div>
              {propertyDetailImages.length > 1 && (
                <>
                  <button
                    className="image-nav-arrow prev-arrow"
                    onClick={() => {
                      const prevIndex = enlargedImageIndex > 0 ? enlargedImageIndex - 1 : propertyDetailImages.length - 1;
                      setEnlargedImageIndex(prevIndex);
                      setEnlargedImage(propertyDetailImages[prevIndex]);
                    }}
                  >
                    ‹
                  </button>
                  <button
                    className="image-nav-arrow next-arrow"
                    onClick={() => {
                      const nextIndex = enlargedImageIndex < propertyDetailImages.length - 1 ? enlargedImageIndex + 1 : 0;
                      setEnlargedImageIndex(nextIndex);
                      setEnlargedImage(propertyDetailImages[nextIndex]);
                    }}
                  >
                    ›
                  </button>
                </>
              )}
            </div>
          </div>
        )}
        {expandedMap && isGlobeMap && (
          <div className="expanded-map-modal" onClick={() => setExpandedMap(null)}>
            <div className="expanded-map" onClick={(e) => e.stopPropagation()}>
              <button className="close-expanded-map" onClick={() => setExpandedMap(null)}>
                ×
              </button>
              <div ref={mapRef} className="leaflet-map"></div>
              <MapPlaceLayers map={placesExpandedMapInstance} />
            </div>
          </div>
        )}
        {showAiStaging && (
          <div className="ai-staging-modal" onClick={() => setShowAiStaging(false)}>
            <div className="ai-staging-content" onClick={(e) => e.stopPropagation()}>
              <h3>AI Room Staging</h3>
              <p>Select room type to generate AI staging:</p>
              <div className="staging-buttons">
                <button
                  className="staging-type-button"
                  onClick={() => handleAiStaging('bedroom')}
                  disabled={stagingLoading}
                >
                  🛏️ Bedroom
                </button>
                <button
                  className="staging-type-button"
                  onClick={() => handleAiStaging('office')}
                  disabled={stagingLoading}
                >
                  💼 Office
                </button>
                <button
                  className="staging-type-button"
                  onClick={() => handleAiStaging('landscape')}
                  disabled={stagingLoading}
                >
                  🌳 Landscape
                </button>
                <button
                  className="staging-type-button"
                  onClick={() => handleAiStaging('room')}
                  disabled={stagingLoading}
                >
                  🏠 Room
                </button>
              </div>
              {stagingLoading && (
                <div className="staging-loading">
                  <div className="loading-spinner"></div>
                  <p>Generating AI staging...</p>
                </div>
              )}
              <button className="close-staging-modal" onClick={() => setShowAiStaging(false)}>
                Cancel
              </button>
            </div>
          </div>
        )}
        <div style={{background: 'rgba(0,0,0,0.85)', padding: '6px 12px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
          <img src={SITE_CONFIG.MLS.LOGO_URL} alt={SITE_CONFIG.MLS.SHORT_NAME} style={{height: '20px', objectFit: 'contain'}} />
          <span style={{fontSize: '10px', color: '#ccc', flex: 1}}>{SITE_CONFIG.MLS.DISCLAIMER} | Brokerage License: {SITE_CONFIG.AGENT.BROKERAGE_LICENSE} | Agent License: {SITE_CONFIG.AGENT.LICENSE}</span>
        </div>
      </div>

      </>
    );
  }

  const latestMobilePropertyIndex = messages.reduce((last, message, index) => message.content === 'properties' ? index : last, -1);
  const latestMobilePropertyMessage = messages[latestMobilePropertyIndex];

  return (
    <div className="action-buttons-container" role="region" aria-label="Real estate chat assistant">
      {window.location.pathname === '/chat' && latestMobilePropertyMessage?.properties?.length > 0 && (
        <LegacyMobilePropertyBrowser message={latestMobilePropertyMessage} pageSize={itemsPerPage}
          onMore={() => handleShowMoreProperties(latestMobilePropertyIndex)}
          onRestart={() => fetchProperties(latestMobilePropertyMessage.searchFilters)}
          onOpen={property => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
          onSave={property => toggleFavorite(property, user)} favorites={likedProperties} images={propertyImages}
          paused={isPropertySearching || Boolean(propertyDetail)} />
      )}
      <div className={`chat-box ${isDarkMode ? 'dark-mode' : ''}`} role="complementary">
        {(isThinking || isPropertySearching) && <p role="status">{isPropertySearching ? 'Searching live listings…' : 'Thinking…'}</p>}
        <div className="chat-messages" ref={messagesContainerRef} role="log" aria-live="polite" aria-label="Chat conversation history">
          <div className="message bot-message welcome-message">
            <div className="agent-profile">
              <div className="agent-avatar">
                <img src="https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/david.hamady.flint_62e436a10ae14e62bcdca74224f02663.png" alt={`${SITE_CONFIG.AGENT.NAME} - Your Real Estate Agent`} className="agent-avatar-img" />
              </div>
              <div className="agent-message">
                Selling your property? Get a free home evaluation, just click the Selling button below
              </div>
            </div>
            <div className="welcome-text">
              Hi! I'm here to help you find your perfect home. I can show you properties, help you sign in, register, or connect you directly with David for a personal consultation.
              <br /><br />
              <strong className="cta-text">How can I help you today?</strong>
            </div>
            <div className="service-buttons">
              <div className="button-row">
                <button
                  className="service-button gold-outline"
                  onClick={() => handleServiceSelect('buying')}
                  aria-label="Select buying service to search for properties to purchase"
                >
                  Buying
                </button>
                <button
                  className="service-button gold-outline"
                  onClick={() => handleServiceSelect('selling')}
                  aria-label="Select selling service to list your property for sale"
                >
                  Selling
                </button>
              </div>
              <div className="button-row">
                <button
                  className="service-button"
                  onClick={() => handleServiceSelect('lease')}
                  aria-label="Select lease service to find rental properties"
                >
                  Lease
                </button>
                <button
                  className="service-button"
                  onClick={() => { setShowLogin(true); setSendButtonEnabled(true); }}
                  aria-label="Sign in to your account to access saved properties and preferences"
                >
                  Sign In
                </button>
                <button
                  className="service-button"
                  onClick={() => { setShowRegistration(true); setSendButtonEnabled(true); }}
                  aria-label="Register for a new account to save properties and get personalized recommendations"
                >
                  Register
                </button>
              </div>
            </div>
          </div>

          {selectedService && (
            <div className="message bot-message">
              <h3 className="form-title">Perfect! Let's get your information</h3>
              <p className="form-subtitle">Tell us a bit about yourself so we can better assist with your {selectedService === 'lease' ? 'leasing' : selectedService} needs</p>
              <form className="chat-form" onSubmit={handleFormSubmit}>
                <HoneypotField />
                <input
                  type="text"
                  placeholder="Enter your zip code"
                  value={zipCode}
                  onChange={(e) => setZipCode(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="tel"
                  placeholder="Enter your phone number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit cta-button" aria-label="Submit your information to get started with property search">Get Started</button>
              </form>
            </div>
          )}
          {showThankYouMessage && (
            <div className="message bot-message">
              {selectedService === 'buying' ? (
                <div>
                  <p>Thank you, {name}! Since you're looking to buy, would you like to see some properties for sale in {zipCode}?</p>
                  <div className="service-buttons">
                    <button className="service-button" onClick={() => { console.log('Fetching properties for zip:', zipCode); fetchProperties({zip: zipCode}); setShowProperties(true); }}>Yes, Show Properties</button>
                    <button className="service-button" onClick={() => setShowThankYouMessage(false)}>Not Right Now</button>
                  </div>
                </div>
              ) : selectedService === 'selling' ? (
                <div>
                  <p>Thank you, {name}! Let's get some details about your property to help with the selling process.</p>
                  <form className="chat-form" onSubmit={handleSellingFormSubmit}>
                <HoneypotField />
                    <input
                      type="text"
                      placeholder="Property location/address"
                      value={propertyLocation}
                      onChange={(e) => setPropertyLocation(e.target.value)}
                      className="form-input"
                      required
                    />
                    <input
                      type="text"
                      placeholder="Property size (e.g., 3 bed, 2 bath)"
                      value={propertySize}
                      onChange={(e) => setPropertySize(e.target.value)}
                      className="form-input"
                      required
                    />
                    <select
                      value={propertyCondition}
                      onChange={(e) => setPropertyCondition(e.target.value)}
                      className="form-input"
                      required
                    >
                      <option value="">Select property condition</option>
                      <option value="excellent">Excellent</option>
                      <option value="good">Good</option>
                      <option value="fair">Fair</option>
                      <option value="needs-work">Needs Work</option>
                    </select>
                    <select
                      value={sellingTimeline}
                      onChange={(e) => setSellingTimeline(e.target.value)}
                      className="form-input"
                      required
                    >
                      <option value="">Select timeline</option>
                      <option value="asap">ASAP</option>
                      <option value="1-3-months">1-3 months</option>
                      <option value="3-6-months">3-6 months</option>
                      <option value="6-months-plus">6+ months</option>
                    </select>
                    <button type="submit" className="form-submit cta-button">Submit Property Details</button>
                  </form>
                </div>
              ) : selectedService === 'lease' ? (
                <p>Thank you, {name}! How else can I help you today?</p>
              ) : (
                <p>Thank you, {name}! How else can I help you today?</p>
              )}
            </div>
          )}
          {messages.map((message, index) => (
            <div key={index} className={`message ${message.type === 'user' ? 'user-message' : 'bot-message'} ${message.content === 'properties' && message.properties?.length > 0 ? 'legacy-property-message' : ''}`}>
              {message.content === 'properties' ? (
                <div>
                  {message.properties.length > 0
                    ? `Found ${message.properties.length} properties:`
                    : message.privateUnavailable
                      ? 'No MLS properties matched this search.'
                      : 'No properties matched this search. Try changing a feature, budget, or location.'}
                  {message.privateUnavailable && (
                    <p role="status">Private listings could not be loaded. These results include MLS listings only.</p>
                  )}
                  {message.properties.length > itemsPerPage && (
                    <div style={{fontSize: '14px', color: '#666', marginBottom: '10px'}}>
                      Showing {Math.min(((message.currentPage || 0) + 1) * itemsPerPage, message.properties.length)} of {message.properties.length} properties
                    </div>
                  )}
                  <div className="properties-list">
                    {message.properties.slice(0, ((message.currentPage || 0) + 1) * itemsPerPage).map((property, propIndex) => (
                      <div key={propIndex} className="property-item" role="article" aria-label={`Property listing: ${property.address || property.street_address || 'Property'} - $${property.list_price || property.current_price || property.price}`}>
                        <script type="application/ld+json">
                          {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "RealEstateProperty",
                            "name": formatPropertyAddress(property),
                            "address": {
                              "@type": "PostalAddress",
                              "streetAddress": formatStreetAddress(property),
                              "addressLocality": property.city,
                              "addressRegion": property.state,
                              "postalCode": property.postal_code
                            },
                            "price": property.current_price || property.price,
                            "priceCurrency": "USD",
                            "numberOfRooms": property.bedrooms_total || property.bedrooms,
                            "propertyType": property.property_type,
                            "url": `${window.location.origin}/listing/${property.listing_key}`
                          })}
                        </script>
                        <div className="property-map">
                          <div
                            className="mini-map clickable"
                            onClick={() => setExpandedMap({...getPropertyCoords(property), address: property.address || `Property ${property.id}`})}
                          >
                            <img
                              src={`https://tile.openstreetmap.org/15/${getTileCoords(getPropertyCoords(property).lat, getPropertyCoords(property).lon, 15).x}/${getTileCoords(getPropertyCoords(property).lat, getPropertyCoords(property).lon, 15).y}.png`}
                              alt={`Map tile showing location of ${property.address || 'property'}`}
                              className="map-tile"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'block';
                              }}
                            />
                            <div className="house-icon">🏠</div>
                            <div className="map-fallback" style={{display: 'none'}}>
                              <div className="map-dot"></div>
                            </div>
                          </div>
                        </div>
                        <div className="property-image">
                          <div
                            className="property-photo clickable"
                            onClick={() => property.isPrivate ? fetchPrivatePropertyDetail(property) : fetchPropertyDetail(property.id, property)}
                            style={{cursor: 'pointer'}}
                          >
                            <PropertyThumbnail listingKey={property.listing_key}
                                src={propertyImages[property.listing_key] || property.first_photo_url || property.image_url || property.photo_url}
                                alt={`Property photo for ${property.address || property.street_address || 'listing'}`}
                                className="property-thumbnail"
                              />
                          </div>
                        </div>
                        <div className="property-details">
                          <div className="property-address">{formatPropertyAddress(property) || `Property ID: ${property.id}`}</div>
                          <div className="property-price">${(property.list_price || property.current_price || property.price)?.toLocaleString()}</div>
                          <div className="property-specs">
                            {(property.bedrooms_total || property.bedrooms) && `${property.bedrooms_total || property.bedrooms} bed`}
                            {property.property_type && ` • ${property.property_type}`}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {message.pageError && <p role="alert">{message.pageError}</p>}
                  {(message.hasMore || message.properties.length > ((message.currentPage || 0) + 1) * itemsPerPage) && (
                    <div style={{textAlign: 'center', marginTop: '15px'}}>
                      <button
                        className="service-button"
                        disabled={message.loadingMore}
                        onClick={() => handleShowMoreProperties(index)}
                        style={{background: '#007bff', color: 'white'}}
                      >
                        {message.loadingMore ? 'Loading…' : message.restartSearch ? 'Restart search' : 'Show more homes'}
                      </button>
                    </div>
                  )}
                </div>
              ) : message.content === 'seller_lead_capture' ? (
                <div>
                  <p>To follow up on your property, I just need a few quick details:</p>
                  <form className="chat-form" onSubmit={handleSellerLeadCaptureSubmit}>
                <HoneypotField />
                    <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" required />
                    <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" required />
                    <button type="submit" className="form-submit cta-button">Submit</button>
                  </form>
                </div>
              ) : message.content === 'buyer_lead_capture' ? (
                <div>
                  <p>I'd love to help you find your next home! Just need a few details:</p>
                  <form className="chat-form" onSubmit={handleBuyerLeadCaptureSubmit}>
                <HoneypotField />
                    <input type="text" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} className="form-input" required />
                    <input type="tel" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-input" required />
                    <input type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="form-input" required />
                    {pendingBuyerParams && !pendingBuyerParams.city && !pendingBuyerParams.zip && (
                      <input type="text" placeholder="City or Zip Code" value={locationInput} onChange={(e) => setLocationInput(e.target.value)} className="form-input" required />
                    )}
                    {pendingBuyerParams && !pendingBuyerParams.maxPrice && (
                      <input type="number" placeholder="Max Price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} className="form-input" />
                    )}
                    <button type="submit" className="form-submit cta-button">Submit</button>
                  </form>
                </div>
              ) : (
                message.content
              )}
            </div>
          ))}
          {showRegistration && (
            <div className="message bot-message">
              Please complete your registration:
              <form className="chat-form" onSubmit={handleRegistrationSubmit}>
                <input
                  type="text"
                  placeholder="Username"
                  value={regName}
                  onChange={(e) => setRegName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={regEmail}
                  onChange={(e) => setRegEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={regPassword}
                  onChange={(e) => setRegPassword(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={regPhoneNumber}
                  onChange={(e) => setRegPhoneNumber(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="text"
                  placeholder="Full Name"
                  value={regFullName}
                  onChange={(e) => setRegFullName(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Register</button>
              </form>
            </div>
          )}
          {showLogin && !showForgotPassword && (
            <div className="message bot-message">
              Please sign in:
              <form className="chat-form" onSubmit={handleLoginSubmit}>
                <input
                  type="text"
                  placeholder="Username or Email"
                  value={loginUsername}
                  onChange={(e) => setLoginUsername(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  value={loginPassword}
                  onChange={(e) => setLoginPassword(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Sign In</button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => setShowForgotPassword(true)}
                >
                  Forgot Password?
                </button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => { setShowLogin(false); setShowRegistration(true); }}
                >
                  Don't have an account? Register
                </button>
              </form>
            </div>
          )}
          {showForgotPassword && (
            <div className="message bot-message">
              Enter your email to reset your password:
              <form className="chat-form" onSubmit={handlePasswordResetSubmit}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <button type="submit" className="form-submit">Send Reset Link</button>
                <button
                  type="button"
                  className="forgot-password-link"
                  onClick={() => { setShowForgotPassword(false); setResetEmail(''); }}
                >
                  Back to Sign In
                </button>
              </form>
            </div>
          )}

        </div>
        <div className="chat-input-container" role="search">
          {!hidePrompts && (
            <div className="prompts-dropdown">
              <button
                className={`prompts-button ${user?.roles?.includes('ROLE_USER') ? 'user-role' : ''} ${user?.roles?.includes('ROLE_ADMIN') ? 'admin-role' : ''}`}
                onClick={() => setShowPrompts(!showPrompts)}
              >
                Prompts ▲
              </button>
              {showPrompts && (
                <div className="prompts-menu">
                  {commonPrompts.map((prompt, index) => (
                    <div
                      key={index}
                      className="prompt-item"
                      onClick={() => handlePromptSelect(prompt.value)}
                    >
                      {prompt.display}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <input
            type="text"
            placeholder={(sendButtonEnabled || user || openChat) ? "Type your message..." : "Please select a service above or sign in first"}
            className="chat-input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={(sendButtonEnabled || user || openChat) ? handleKeyPress : undefined}
            disabled={!(sendButtonEnabled || user || openChat) || isThinking || isPropertySearching}
            aria-label="Chat message input - Ask about properties, schedule showings, or get real estate assistance"
          />
          <button
            className="send-button" disabled={isThinking || isPropertySearching}
            onClick={(e) => {
              if (!(sendButtonEnabled || user || openChat)) {
                setShowRegistration(true);
                setSendButtonEnabled(true);
              } else {
                handleSendMessage(e);
              }
            }}
            style={{ opacity: (sendButtonEnabled || user || openChat) ? 1 : 0.5, cursor: 'pointer' }}
            aria-label="Send chat message to AI assistant"
          >
            Send
          </button>
        </div>
      </div>
      {expandedMap && (
        <div className="expanded-map-modal" onClick={() => setExpandedMap(null)}>
          <div className="expanded-map" onClick={(e) => e.stopPropagation()}>
            <button className="close-expanded-map" onClick={() => setExpandedMap(null)}>
              ×
            </button>
            <div ref={mapRef} className="leaflet-map"></div>
              <MapPlaceLayers map={placesExpandedMapInstance} />
          </div>
        </div>
      )}
      {propertyDetail && (
        <div className="expanded-map-modal" onClick={closePropertyDetail}>
          <><FleetPropertyDetailActions home={propertyDetail} user={user} /><div className="property-detail-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-expanded-map" onClick={() => {
              if (directListingKey) {
                closePropertyDetail();
                navigate('/');
              } else {
                closePropertyDetail();
              }
            }}>
              ×
            </button>
            <button
              className="link-button"
              onClick={() => {
                const url = getPropertyShareUrl(propertyDetail, SITE_CONFIG);
                navigator.clipboard.writeText(url).then(() => {
                  setShowCopySuccess(true);
                  setTimeout(() => setShowCopySuccess(false), 3000);
                }).catch(err => {
                  console.error('Failed to copy:', err);
                  alert('Failed to copy link');
                });
              }}
              aria-label="Copy property link to clipboard"
            >
              🔗
            </button>
            <button
              className={`heart-button ${likedProperties.has(propertyDetail.listing_key) ? 'liked' : ''}`}
              onClick={() => toggleFavorite(propertyDetail, user)}
            >
              {likedProperties.has(propertyDetail.listing_key) ? '💖' : '❤️'}
            </button>
            <div className="property-detail-content">
              <div className="property-header">
<div className={`property-overview-grid${mapCoordinates(propertyDetail) ? '' : ' property-overview-grid--no-map'}`}><div className="property-overview-summary">
                {!propertyDetail.isPrivate && (propertyDetail.list_agent_full_name || propertyDetail.list_office_name) && (
                  <div style={{fontSize: '11px', color: '#888', marginBottom: '6px', textAlign: 'left'}}>
                    {propertyDetail.list_agent_full_name && (
                      <div>Listing Agent: {propertyDetail.list_agent_full_name}{propertyDetail.list_agent_mls_id ? ` (${propertyDetail.list_agent_mls_id})` : ''}</div>
                    )}
                    {propertyDetail.list_office_name && (
                      <div>Office: {propertyDetail.list_office_name}</div>
                    )}
                  </div>
                )}
                <h2>${(propertyDetail.list_price || propertyDetail.current_price)?.toLocaleString()}</h2>
                <p className="property-address">{formatPropertyAddress(propertyDetail)}</p>


                </div><PropertyLocationMap property={propertyDetail} /></div>
<div className="property-images">
                  {imagesLoading ? (
                    <div style={{textAlign: 'center', padding: '20px', color: '#007bff', fontSize: '14px'}}>
                      <div style={{display: 'inline-block', marginRight: '8px', animation: 'spin 1s linear infinite', fontSize: '16px'}}>⟳</div>
                      Checking for images...
                    </div>
                  ) : propertyDetailImages.length > 0 ? (
                    propertyDetailImages.map((imageUrl, index) => (
                      <div key={index} className="property-detail-image" onClick={() => { setEnlargedImage(imageUrl); setEnlargedImageIndex(index); }}>
                        <img src={imageUrl} alt={`Property ${index + 1}`} onLoad={() => rememberPropertyPhoto(propertyDetail?.listing_key, imageUrl)} />
                      </div>
                    ))
                  ) : (
                    <div style={{textAlign: 'center', padding: '20px', color: '#666', fontSize: '14px'}}>
                      No images available for this property
                    </div>
                  )}
                </div>

                {propertyDetail.features?.public_remarks && (
                  <div className="property-description">
                    <h3>Property Description</h3>
                    <p>{propertyDetail.features.public_remarks}</p>
                  </div>
                )}
              </div>

              <div className="property-columns">
                <div className="property-column">
                  <h3>Property Details</h3>
                  <p><strong>Property Type:</strong> {propertyDetail.property_type}</p>
                  {propertyDetail.property_sub_type && <p><strong>Property Sub Type:</strong> {propertyDetail.property_sub_type}</p>}
                  <p><strong>Listing Key:</strong> {propertyDetail.listing_key}</p>
                  <p><strong>List Price:</strong> ${propertyDetail.list_price?.toLocaleString()}</p>
                  {propertyDetail.original_list_price && <p><strong>Original List Price:</strong> ${propertyDetail.original_list_price?.toLocaleString()}</p>}
                  <p><strong>Living Area:</strong> {propertyDetail.living_area} sq ft</p>
                  <p><strong>Building Area:</strong> {propertyDetail.building_area_total} sq ft</p>
                  <p><strong>Year Built:</strong> {propertyDetail.year_built}</p>
                  {propertyDetail.stories && <p><strong>Stories:</strong> {propertyDetail.stories}</p>}
                  {propertyDetail.listing_contract_date && <p><strong>Listed Date:</strong> {new Date(propertyDetail.listing_contract_date).toLocaleDateString()}</p>}
                  {propertyDetail.listing_contract_date && <p><strong>Days on Market:</strong> {Math.floor((Date.now() - new Date(propertyDetail.listing_contract_date)) / 86400000)}</p>}
                  {(propertyDetail.updated_at || propertyDetail.created_at) && <p><strong>Last Updated:</strong> {new Date(propertyDetail.updated_at || propertyDetail.created_at).toLocaleString()}</p>}

                  {propertyDetail.land && (
                    <div>
                      <h3>Land Details</h3>
                      {propertyDetail.land.lot_size_acres && <p><strong>Lot Size:</strong> {propertyDetail.land.lot_size_acres} acres ({propertyDetail.land.lot_size_square_feet?.toLocaleString()} sq ft)</p>}
                      {propertyDetail.land.lot_features && <p><strong>Land Lot Features:</strong> {propertyDetail.land.lot_features}</p>}
                      {propertyDetail.land.zoning && <p><strong>Zoning:</strong> {propertyDetail.land.zoning}</p>}
                    </div>
                  )}

                  <h3>Rooms & Bathrooms</h3>
                  {propertyDetail.bedrooms_total != null && <p><strong>Bedrooms:</strong> {propertyDetail.bedrooms_total}</p>}
                  {propertyDetail.bathrooms_full != null && <p><strong>Full Bathrooms:</strong> {propertyDetail.bathrooms_full}</p>}
                  {propertyDetail.bathrooms_half != null && <p><strong>Half Bathrooms:</strong> {propertyDetail.bathrooms_half}</p>}
                  {propertyDetail.fireplaces_total != null && <p><strong>Fireplaces:</strong> {propertyDetail.fireplaces_total}</p>}

                  {propertyDetail.schools && (
                    <div>
                      <h3>Schools</h3>
                      <p><strong>Elementary:</strong> {propertyDetail.schools.elementary_school}</p>
                      <p><strong>Middle:</strong> {propertyDetail.schools.middle_school}</p>
                      <p><strong>High:</strong> {propertyDetail.schools.high_school}</p>
                    </div>
                  )}
                </div>

                <div className="property-column">
                  <h3>Features & Amenities</h3>
                  {propertyDetail.features?.garage_spaces != null && <p><strong>Garage:</strong> {propertyDetail.features.garage_spaces} spaces</p>}
                  {propertyDetail.features?.heating && <p><strong>Heating:</strong> {propertyDetail.features.heating}</p>}
                  {propertyDetail.features?.cooling && <p><strong>Cooling:</strong> {propertyDetail.features.cooling}</p>}
                  {propertyDetail.features?.water_source && <p><strong>Water Source:</strong> {propertyDetail.features.water_source}</p>}
                  {propertyDetail.foundation_details && <p><strong>Foundation:</strong> {propertyDetail.foundation_details}</p>}
                  {propertyDetail.roof && <p><strong>Roof:</strong> {propertyDetail.roof}</p>}
                  {propertyDetail.sewer && <p><strong>Sewer:</strong> {propertyDetail.sewer}</p>}

                  {propertyDetail.features?.appliances && (
                    <div>
                      <h3>Appliances</h3>
                      <p className="feature-list">{propertyDetail.features.appliances.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.interior_features && (
                    <div>
                      <h3>Interior Features</h3>
                      <p className="feature-list">{propertyDetail.features.interior_features.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.exterior_features && (
                    <div>
                      <h3>Exterior Features</h3>
                      <p className="feature-list">{propertyDetail.features.exterior_features.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.association?.association_name && (
                    <div>
                      <h3>HOA Information</h3>
                      <p><strong>Association:</strong> {propertyDetail.association.association_name}</p>
                      {propertyDetail.association.association_fee && <p><strong>HOA Fee:</strong> ${propertyDetail.association.association_fee} {propertyDetail.association.fee_frequency}</p>}
                    </div>
                  )}

                  {propertyDetail.features?.lots_features && (
                    <div>
                      <h3>Lot Features</h3>
                      <p className="feature-list">{propertyDetail.features.lots_features.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.patio_and_porch_features && (
                    <div>
                      <h3>Patio & Porch</h3>
                      <p className="feature-list">{propertyDetail.features.patio_and_porch_features.split(',').join(', ')}</p>
                    </div>
                  )}

                  {propertyDetail.features?.fencing && (
                    <div>
                      <h3>Fencing</h3>
                      <p>{propertyDetail.features.fencing}</p>
                    </div>
                  )}
                </div>
              </div>
              {!propertyDetail.isPrivate && (
                <div style={{borderTop: '1px solid #ddd', marginTop: '20px', paddingTop: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap'}}>
                  <img src={SITE_CONFIG.MLS.LOGO_URL} alt={SITE_CONFIG.MLS.SHORT_NAME} style={{height: '32px', objectFit: 'contain'}} />
                  <div style={{fontSize: '12px', color: '#666', flex: 1}}>
                    <span>{SITE_CONFIG.MLS.DISCLAIMER}</span>
                  </div>
                </div>
              )}
            </div>
          </div></>
        </div>
      )}
      {enlargedImage && (
        <div className="enlarged-image-modal" onClick={() => { setEnlargedImage(null); setStagingImage(null); }}>
          <div className="enlarged-image-container" onClick={(e) => e.stopPropagation()}>
            <div className="image-wrapper">
              <button className="close-enlarged-image" onClick={() => { setEnlargedImage(null); setStagingImage(null); }}>
                ×
              </button>
              <button className="ai-staging-button" onClick={() => setShowAiStaging(true)}>
                🤖
              </button>
              <img src={stagingImage || enlargedImage} alt="Enlarged Property" className="enlarged-image" />
              {stagingImage && (
                <button className="reset-staging-button" onClick={() => setStagingImage(null)}>
                  Original
                </button>
              )}
            </div>
            {propertyDetailImages.length > 1 && (
              <>
                <button
                  className="image-nav-arrow prev-arrow"
                  onClick={() => {
                    const prevIndex = enlargedImageIndex > 0 ? enlargedImageIndex - 1 : propertyDetailImages.length - 1;
                    setEnlargedImageIndex(prevIndex);
                    setEnlargedImage(propertyDetailImages[prevIndex]);
                  }}
                >
                  ‹
                </button>
                <button
                  className="image-nav-arrow next-arrow"
                  onClick={() => {
                    const nextIndex = enlargedImageIndex < propertyDetailImages.length - 1 ? enlargedImageIndex + 1 : 0;
                    setEnlargedImageIndex(nextIndex);
                    setEnlargedImage(propertyDetailImages[nextIndex]);
                  }}
                >
                  ›
                </button>
              </>
            )}
          </div>
        </div>
      )}
      {showAiStaging && (
        <div className="ai-staging-modal" onClick={() => setShowAiStaging(false)}>
          <div className="ai-staging-content" onClick={(e) => e.stopPropagation()}>
            <h3>AI Room Staging</h3>
            <p>Select room type to generate AI staging:</p>
            <div className="staging-buttons">
              <button
                className="staging-type-button"
                onClick={() => handleAiStaging('bedroom')}
                disabled={stagingLoading}
              >
                🛏️ Bedroom
              </button>
              <button
                className="staging-type-button"
                onClick={() => handleAiStaging('office')}
                disabled={stagingLoading}
              >
                💼 Office
              </button>
              <button
                className="staging-type-button"
                onClick={() => handleAiStaging('landscape')}
                disabled={stagingLoading}
              >
                🌳 Landscape
              </button>
              <button
                className="staging-type-button"
                onClick={() => handleAiStaging('room')}
                disabled={stagingLoading}
              >
                🏠 Room
              </button>
            </div>
            {stagingLoading && (
              <div className="staging-loading">
                <div className="loading-spinner"></div>
                <p>Generating AI staging...</p>
              </div>
            )}
            <button className="close-staging-modal" onClick={() => setShowAiStaging(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {showCopySuccess && (
        <div className="like-success-notification">
          <div className="like-success-content">
            <span className="like-success-icon">🔗</span>
            <span className="like-success-text">Link copied to clipboard!</span>
          </div>
        </div>
      )}

    </div>
  );
};

export default ActionButtons;
